export const indiaVsNewzealandPlayerList = [
  {
    id: '63cbb73896851a4d7f848440',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '1082',
    teamId: 7,
    firstName: 'Glenn Phillips',
    lastName: '',
    middleName: '',
    shortName: 'Glenn Phillips',
    title: 'Glenn Phillips',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 70
  },
  {
    id: '63cbb73896851a4d7f848441',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '1083',
    teamId: 7,
    firstName: 'Finn Allen',
    lastName: '',
    middleName: '',
    shortName: 'Finn Allen',
    title: 'Finn Allen',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 56
  },
  {
    id: '63cbb73896851a4d7f84844f',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '16509',
    teamId: 7,
    firstName: 'Daryl Mitchell',
    lastName: '',
    middleName: '',
    shortName: 'DJ Mitchell',
    title: 'Daryl Mitchell',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 84
  },
  {
    id: '63cbb73896851a4d7f848451',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '16557',
    teamId: 7,
    firstName: 'Michael Bracewell',
    lastName: '',
    middleName: '',
    shortName: 'Michael Bracewell',
    title: 'Michael Bracewell',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 218
  },
  {
    id: '63cbb73896851a4d7f848453',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '16566',
    teamId: 7,
    firstName: 'Jacob Duffy',
    lastName: '',
    middleName: '',
    shortName: 'JA Duffy',
    title: 'Jacob Duffy',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbb73896851a4d7f848455',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '16643',
    teamId: 7,
    firstName: 'Lockie Ferguson',
    lastName: '',
    middleName: '',
    shortName: 'LH Ferguson',
    title: 'Lockie Ferguson',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 43
  },
  {
    id: '63cbb73896851a4d7f848444',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '1708',
    teamId: 7,
    firstName: 'Mark Chapman',
    lastName: '',
    middleName: '',
    shortName: 'MS Chapman',
    title: 'Mark Chapman',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbb73896851a4d7f848446',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '1923',
    teamId: 7,
    firstName: 'Mitchell Santner',
    lastName: '',
    middleName: '',
    shortName: 'Mitchell Santner',
    title: 'Mitchell Santner',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 184
  },
  {
    id: '63cbb73896851a4d7f848449',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '1927',
    teamId: 7,
    firstName: 'Ish Sodhi',
    lastName: '',
    middleName: '',
    shortName: 'Ish Sodhi',
    title: 'Ish Sodhi',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbb73896851a4d7f84844c',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '1967',
    teamId: 7,
    firstName: 'Henry Nicholls',
    lastName: '',
    middleName: '',
    shortName: 'HM Nicholls',
    title: 'Henry Nicholls',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 25
  },
  {
    id: '63cbb73896851a4d7f848457',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '44185',
    teamId: 7,
    firstName: 'Tom Latham',
    lastName: '',
    middleName: '',
    shortName: 'Tom Latham',
    title: 'Tom Latham',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 62
  },
  {
    id: '63cbb73896851a4d7f84845a',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '46141',
    teamId: 7,
    firstName: 'Devon Conway',
    lastName: '',
    middleName: '',
    shortName: 'Devon Conway',
    title: 'Devon Conway',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 100,
    totalPointsOfPreviousMatches: 28
  },
  {
    id: '63cbb73896851a4d7f84845e',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '46310',
    teamId: 7,
    firstName: 'Blair Tickner',
    lastName: '',
    middleName: '',
    shortName: 'BM Tickner',
    title: 'Blair Tickner',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 36
  },
  {
    id: '63cbb73896851a4d7f848461',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '49103',
    teamId: 7,
    firstName: 'Doug Bracewell',
    lastName: '',
    middleName: '',
    shortName: 'DAJ Bracewell',
    title: 'Doug Bracewell',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbb73896851a4d7f848463',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '90808',
    teamId: 7,
    firstName: 'Henry Shipley',
    lastName: '',
    middleName: '',
    shortName: 'HB Shipley',
    title: 'Henry Shipley',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 97
  },
  {
    id: '63cbb73896851a4d7f848488',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '104934',
    teamId: 25,
    firstName: 'Umran Malik',
    lastName: '',
    middleName: '',
    shortName: 'Umran Malik',
    title: 'Umran Malik',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbb73896851a4d7f848479',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '1097',
    teamId: 25,
    firstName: 'Ishan Kishan',
    lastName: '',
    middleName: '',
    shortName: 'Ishan Kishan',
    title: 'Ishan Kishan',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 31
  },
  {
    id: '63cbb73896851a4d7f84847a',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '1101',
    teamId: 25,
    firstName: 'Washington Sundar',
    lastName: '',
    middleName: '',
    shortName: 'Washington Sundar',
    title: 'Washington Sundar',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 80
  },
  {
    id: '63cbb73896851a4d7f848467',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '115',
    teamId: 25,
    firstName: 'Rohit Sharma',
    lastName: '',
    middleName: '',
    shortName: 'Rohit Sharma',
    title: 'Rohit Sharma',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 118
  },
  {
    id: '63cbb73896851a4d7f84846a',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '119',
    teamId: 25,
    firstName: 'Virat Kohli',
    lastName: '',
    middleName: '',
    shortName: 'Virat Kohli',
    title: 'Virat Kohli',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 30
  },
  {
    id: '63cbb73896851a4d7f84846d',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '131',
    teamId: 25,
    firstName: 'Mohammed Shami',
    lastName: '',
    middleName: '',
    shortName: 'M Shami',
    title: 'Mohammed Shami',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 146
  },
  {
    id: '63cbb73896851a4d7f84847b',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '53855',
    teamId: 25,
    firstName: 'Kona Srikar Bharat',
    lastName: '',
    middleName: '',
    shortName: 'KS Bharat',
    title: 'Kona Srikar Bharat',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbb73896851a4d7f84846e',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '598',
    teamId: 25,
    firstName: 'Suryakumar Yadav',
    lastName: '',
    middleName: '',
    shortName: 'SA Yadav',
    title: 'Suryakumar Yadav',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 69
  },
  {
    id: '63cbb73896851a4d7f848470',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '654',
    teamId: 25,
    firstName: 'Yuzvendra Chahal',
    lastName: '',
    middleName: '',
    shortName: 'Yuzvendra Chahal',
    title: 'Yuzvendra Chahal',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbb73896851a4d7f848473',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '727',
    teamId: 25,
    firstName: 'Hardik Pandya',
    lastName: '',
    middleName: '',
    shortName: 'HH Pandya',
    title: 'Hardik Pandya',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 140
  },
  {
    id: '63cbb73896851a4d7f848476',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '775',
    teamId: 25,
    firstName: 'Kuldeep Yadav',
    lastName: '',
    middleName: '',
    shortName: 'KL Yadav',
    title: 'Kuldeep Yadav',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Wrist Spin',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 126
  },
  {
    id: '63cbb73896851a4d7f848477',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '810',
    teamId: 25,
    firstName: 'Shardul Thakur',
    lastName: '',
    middleName: '',
    shortName: 'Shardul Thakur',
    title: 'Shardul Thakur',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 98
  },
  {
    id: '63cbb73896851a4d7f84847d',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '90351',
    teamId: 25,
    firstName: 'Rajat Patidar',
    lastName: '',
    middleName: '',
    shortName: 'RM Patidar',
    title: 'Rajat Patidar',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbb73896851a4d7f848482',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '90381',
    teamId: 25,
    firstName: 'Mohammed Siraj',
    lastName: '',
    middleName: '',
    shortName: 'Mohammed Siraj',
    title: 'Mohammed Siraj',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 163
  },
  {
    id: '63cbb73896851a4d7f848486',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '90739',
    teamId: 25,
    firstName: 'Shubman Gill',
    lastName: '',
    middleName: '',
    shortName: 'Shubman Gill',
    title: 'Shubman Gill',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 100,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 335
  },
  {
    id: '63cbb73896851a4d7f848487',
    matchId: '63cbb6ed96851a4d7f84726c',
    playerId: '94088',
    teamId: 25,
    firstName: 'Shahbaz Ahmed',
    lastName: '',
    middleName: '',
    shortName: 'Shahbaz Ahmed',
    title: 'Shahbaz Ahmed',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 8
  }
];
export const pakVsAusPlayerList = [
  {
    id: '62487296bc54653691c42eee',
    matchId: '62487289bc54653691c41e41',
    playerId: '1955',
    teamId: 5,
    firstName: 'Ashton Agar',
    lastName: '',
    middleName: '',
    shortName: 'AC Agar',
    title: 'Ashton Agar',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62487296bc54653691c42ef8',
    matchId: '62487289bc54653691c41e41',
    playerId: '1965',
    teamId: 5,
    firstName: 'Adam Zampa',
    lastName: '',
    middleName: '',
    shortName: 'A Zampa',
    title: 'Adam Zampa',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 7.25,
    strikeRate: 0,
    points: 29
  },
  {
    id: '62487296bc54653691c42ed4',
    matchId: '62487289bc54653691c41e41',
    playerId: '43471',
    teamId: 5,
    firstName: 'Travis Head',
    lastName: '',
    middleName: '',
    shortName: 'TM Head',
    title: 'Travis Head',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 9.5,
    run: 26,
    boundary: 3,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 8.5,
    strikeRate: 185.71,
    points: 41
  },
  {
    id: '62487296bc54653691c42ee8',
    matchId: '62487289bc54653691c41e41',
    playerId: '43482',
    teamId: 5,
    firstName: 'Marcus Stoinis',
    lastName: '',
    middleName: '',
    shortName: 'MP Stoinis',
    title: 'Marcus Stoinis',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 9.5,
    run: 23,
    boundary: 5,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 255.56,
    points: 40
  },
  {
    id: '62487296bc54653691c42f01',
    matchId: '62487289bc54653691c41e41',
    playerId: '43582',
    teamId: 5,
    firstName: 'Jason Behrendorff',
    lastName: '',
    middleName: '',
    shortName: 'JP Behrendorff',
    title: 'Jason Behrendorff',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62487296bc54653691c42f09',
    matchId: '62487289bc54653691c41e41',
    playerId: '43605',
    teamId: 5,
    firstName: 'Ben Dwarshuis',
    lastName: '',
    middleName: '',
    shortName: 'Ben Dwarshuis',
    title: 'Ben Dwarshuis',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 14,
    strikeRate: 0,
    points: -2
  },
  {
    id: '62487296bc54653691c42f06',
    matchId: '62487289bc54653691c41e41',
    playerId: '43621',
    teamId: 5,
    firstName: 'Mitchell Swepson',
    lastName: '',
    middleName: '',
    shortName: 'Mitchell Swepson',
    title: 'Mitchell Swepson',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62487296bc54653691c42ee0',
    matchId: '62487289bc54653691c41e41',
    playerId: '43625',
    teamId: 5,
    firstName: 'Ben McDermott',
    lastName: '',
    middleName: '',
    shortName: 'BR McDermott',
    title: 'Ben McDermott',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 22,
    boundary: 3,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 115.79,
    points: 37
  },
  {
    id: '62487296bc54653691c42ee4',
    matchId: '62487289bc54653691c41e41',
    playerId: '52897',
    teamId: 5,
    firstName: 'Matt Renshaw',
    lastName: '',
    middleName: '',
    shortName: 'Matt Renshaw',
    title: 'Matt Renshaw',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62487296bc54653691c42edc',
    matchId: '62487289bc54653691c41e41',
    playerId: '53601',
    teamId: 5,
    firstName: 'Marnus Labuschagne',
    lastName: '',
    middleName: '',
    shortName: 'Marnus Labuschagne',
    title: 'Marnus Labuschagne',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 9,
    run: 2,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 50,
    points: 14
  },
  {
    id: '62487296bc54653691c42ecf',
    matchId: '62487289bc54653691c41e41',
    playerId: '55106',
    teamId: 5,
    firstName: 'Alex Carey',
    lastName: '',
    middleName: '',
    shortName: 'AT Carey',
    title: 'Alex Carey',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62487296bc54653691c42ed2',
    matchId: '62487289bc54653691c41e41',
    playerId: '55846',
    teamId: 5,
    firstName: 'Josh Inglis',
    lastName: '',
    middleName: '',
    shortName: 'JP Inglis',
    title: 'Josh Inglis',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8,
    run: 24,
    boundary: 2,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 160,
    points: 44
  },
  {
    id: '62487296bc54653691c42efc',
    matchId: '62487289bc54653691c41e41',
    playerId: '651',
    teamId: 5,
    firstName: 'Sean Abbott',
    lastName: '',
    middleName: '',
    shortName: 'Sean Abbott',
    title: 'Sean Abbott',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 7,
    strikeRate: 0,
    points: 39
  },
  {
    id: '62487296bc54653691c42ed8',
    matchId: '62487289bc54653691c41e41',
    playerId: '73',
    teamId: 5,
    firstName: 'Aaron Finch',
    lastName: '',
    middleName: '',
    shortName: 'AJ Finch',
    title: 'Aaron Finch',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 9,
    run: 55,
    boundary: 6,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 122.22,
    points: 81
  },
  {
    id: '62487296bc54653691c42ef4',
    matchId: '62487289bc54653691c41e41',
    playerId: '93130',
    teamId: 5,
    firstName: 'Cameron Green',
    lastName: '',
    middleName: '',
    shortName: 'C Green',
    title: 'Cameron Green',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 2,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 5.33,
    strikeRate: 28.57,
    points: 68
  },
  {
    id: '62487296bc54653691c42f0e',
    matchId: '62487289bc54653691c41e41',
    playerId: '96089',
    teamId: 5,
    firstName: 'Nathan Ellis',
    lastName: '',
    middleName: '',
    shortName: 'Nathan Ellis',
    title: 'Nathan Ellis',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 4,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 1,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 7,
    strikeRate: 0,
    points: 126
  },
  {
    id: '62487296bc54653691c42f37',
    matchId: '62487289bc54653691c41e41',
    playerId: '1167',
    teamId: 13,
    firstName: 'Shadab Khan',
    lastName: '',
    middleName: '',
    shortName: 'SH Khan',
    title: 'Shadab Khan',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62487296bc54653691c42f3d',
    matchId: '62487289bc54653691c41e41',
    playerId: '1771',
    teamId: 13,
    firstName: 'Iftikhar Ahmed',
    lastName: '',
    middleName: '',
    shortName: 'Iftikhar Ahmed',
    title: 'Iftikhar Ahmed',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8,
    run: 13,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 100,
    points: 18
  },
  {
    id: '62487296bc54653691c42f23',
    matchId: '62487289bc54653691c41e41',
    playerId: '43370',
    teamId: 13,
    firstName: 'Fakhar Zaman',
    lastName: '',
    middleName: '',
    shortName: 'FK Zaman',
    title: 'Fakhar Zaman',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 1,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 2
  },
  {
    id: '62487296bc54653691c42f1e',
    matchId: '62487289bc54653691c41e41',
    playerId: '43371',
    teamId: 13,
    firstName: 'Babar Azam',
    lastName: '',
    middleName: '',
    shortName: 'Babar Azam',
    title: 'Babar Azam',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 10,
    run: 66,
    boundary: 6,
    six: 2,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 143.48,
    points: 90
  },
  {
    id: '62487296bc54653691c42f12',
    matchId: '62487289bc54653691c41e41',
    playerId: '44054',
    teamId: 13,
    firstName: 'Mohammad Rizwan',
    lastName: '',
    middleName: '',
    shortName: 'Mohammad Rizwan',
    title: 'Mohammad Rizwan',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 9.5,
    run: 23,
    boundary: 1,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 1,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 121.05,
    points: 50
  },
  {
    id: '62487296bc54653691c42f2a',
    matchId: '62487289bc54653691c41e41',
    playerId: '44083',
    teamId: 13,
    firstName: 'Asif Ali',
    lastName: '',
    middleName: '',
    shortName: 'Asif Ali',
    title: 'Asif Ali',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8.5,
    run: 3,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 60,
    points: 15
  },
  {
    id: '62487296bc54653691c42f56',
    matchId: '62487289bc54653691c41e41',
    playerId: '44099',
    teamId: 13,
    firstName: 'Hasan Ali',
    lastName: '',
    middleName: '',
    shortName: 'Hasan Ali',
    title: 'Hasan Ali',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8.5,
    run: 10,
    boundary: 1,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 10,
    strikeRate: 0,
    points: 15
  },
  {
    id: '62487296bc54653691c42f2d',
    matchId: '62487289bc54653691c41e41',
    playerId: '45384',
    teamId: 13,
    firstName: 'Khushdil Shah',
    lastName: '',
    middleName: '',
    shortName: 'Khushdil Shah',
    title: 'Khushdil Shah',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8.5,
    run: 24,
    boundary: 3,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 9,
    strikeRate: 114.29,
    points: 31
  },
  {
    id: '62487296bc54653691c42f64',
    matchId: '62487289bc54653691c41e41',
    playerId: '45496',
    teamId: 13,
    firstName: 'Asif Afridi',
    lastName: '',
    middleName: '',
    shortName: 'Asif Afridi',
    title: 'Asif Afridi',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62487296bc54653691c42f5a',
    matchId: '62487289bc54653691c41e41',
    playerId: '53228',
    teamId: 13,
    firstName: 'Usman Qadir',
    lastName: '',
    middleName: '',
    shortName: 'Usman Qadir',
    title: 'Usman Qadir',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8.5,
    run: 18,
    boundary: 2,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 8.25,
    strikeRate: 0,
    points: 84
  },
  {
    id: '62487296bc54653691c42f5e',
    matchId: '62487289bc54653691c41e41',
    playerId: '53453',
    teamId: 13,
    firstName: 'Zahid Mahmood',
    lastName: '',
    middleName: '',
    shortName: 'Zahid Mahmood',
    title: 'Zahid Mahmood',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62487296bc54653691c42f41',
    matchId: '62487289bc54653691c41e41',
    playerId: '58152',
    teamId: 13,
    firstName: 'Mohammad Wasim',
    lastName: '',
    middleName: '',
    shortName: 'Mohammad Wasim',
    title: 'Mohammad Wasim',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8,
    run: 2,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 7.5,
    strikeRate: 0,
    points: 72
  },
  {
    id: '62487296bc54653691c42f69',
    matchId: '62487289bc54653691c41e41',
    playerId: '91267',
    teamId: 13,
    firstName: 'Shahnawaz Dahani',
    lastName: '',
    middleName: '',
    shortName: 'Shahnawaz Dahani',
    title: 'Shahnawaz Dahani',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62487296bc54653691c42f47',
    matchId: '62487289bc54653691c41e41',
    playerId: '92381',
    teamId: 13,
    firstName: 'Haris Rauf',
    lastName: '',
    middleName: '',
    shortName: 'Haris Rauf',
    title: 'Haris Rauf',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 11.05,
    strikeRate: 0,
    points: 25
  },
  {
    id: '62487296bc54653691c42f4f',
    matchId: '62487289bc54653691c41e41',
    playerId: '92991',
    teamId: 13,
    firstName: 'Shaheen Afridi',
    lastName: '',
    middleName: '',
    shortName: 'S Afridi',
    title: 'Shaheen Afridi',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Medium',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 5.25,
    strikeRate: 0,
    points: 66
  },
  {
    id: '62487296bc54653691c42f32',
    matchId: '62487289bc54653691c41e41',
    playerId: '95302',
    teamId: 13,
    firstName: 'Haider Ali',
    lastName: '',
    middleName: '',
    shortName: 'Haider Ali',
    title: 'Haider Ali',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62487296bc54653691c42f18',
    matchId: '62487289bc54653691c41e41',
    playerId: '96798',
    teamId: 13,
    firstName: 'Mohammad Haris',
    lastName: '',
    middleName: '',
    shortName: 'Mohammad Haris',
    title: 'Mohammad Haris',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  }
];

export const pakVsNzPlayerList = [
  {
    id: '63be86fe0901e17d0f43306b',
    matchId: '63be86840901e17d0f43117e',
    playerId: '1082',
    teamId: 7,
    firstName: 'Glenn Phillips',
    lastName: '',
    middleName: '',
    shortName: 'Glenn Phillips',
    title: 'Glenn Phillips',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 63,
    boundary: 4,
    six: 4,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 150,
    points: 89
  },
  {
    id: '63be86fe0901e17d0f433063',
    matchId: '63be86840901e17d0f43117e',
    playerId: '1083',
    teamId: 7,
    firstName: 'Finn Allen',
    lastName: '',
    middleName: '',
    shortName: 'Finn Allen',
    title: 'Finn Allen',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 25,
    boundary: 4,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 100,
    points: 35
  },
  {
    id: '63be86fe0901e17d0f433095',
    matchId: '63be86840901e17d0f43117e',
    playerId: '141',
    teamId: 13,
    firstName: 'Haris Sohail',
    lastName: '',
    middleName: '',
    shortName: 'H Sohail',
    title: 'Haris Sohail',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8.5,
    run: 22,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 88,
    points: 27
  },
  {
    id: '63be86fe0901e17d0f433072',
    matchId: '63be86840901e17d0f43117e',
    playerId: '16509',
    teamId: 7,
    firstName: 'Daryl Mitchell',
    lastName: '',
    middleName: '',
    shortName: 'DJ Mitchell',
    title: 'Daryl Mitchell',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 31,
    boundary: 1,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 86.11,
    points: 38
  },
  {
    id: '63be86fe0901e17d0f433073',
    matchId: '63be86840901e17d0f43117e',
    playerId: '16557',
    teamId: 7,
    firstName: 'Michael Bracewell',
    lastName: '',
    middleName: '',
    shortName: 'Michael Bracewell',
    title: 'Michael Bracewell',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 8,
    boundary: 0,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 4.4,
    strikeRate: 133.33,
    points: 41
  },
  {
    id: '63be86fe0901e17d0f433077',
    matchId: '63be86840901e17d0f43117e',
    playerId: '16643',
    teamId: 7,
    firstName: 'Lockie Ferguson',
    lastName: '',
    middleName: '',
    shortName: 'LH Ferguson',
    title: 'Lockie Ferguson',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 6.3,
    strikeRate: 0,
    points: 54
  },
  {
    id: '63be86fe0901e17d0f43309b',
    matchId: '63be86840901e17d0f43117e',
    playerId: '1760',
    teamId: 13,
    firstName: 'Mohammad Nawaz',
    lastName: '',
    middleName: '',
    shortName: 'Mohammad Nawaz',
    title: 'Mohammad Nawaz',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8,
    run: 8,
    boundary: 0,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 5.3,
    strikeRate: 88.89,
    points: 47
  },
  {
    id: '63be86fe0901e17d0f43306e',
    matchId: '63be86840901e17d0f43117e',
    playerId: '1923',
    teamId: 7,
    firstName: 'Mitchell Santner',
    lastName: '',
    middleName: '',
    shortName: 'Mitchell Santner',
    title: 'Mitchell Santner',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 15,
    boundary: 1,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 6.4,
    strikeRate: 88.24,
    points: 20
  },
  {
    id: '63be86fe0901e17d0f433075',
    matchId: '63be86840901e17d0f43117e',
    playerId: '1927',
    teamId: 7,
    firstName: 'Ish Sodhi',
    lastName: '',
    middleName: '',
    shortName: 'Ish Sodhi',
    title: 'Ish Sodhi',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 9,
    run: 2,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 5,
    strikeRate: 0,
    points: 37
  },
  {
    id: '63be86fe0901e17d0f43306c',
    matchId: '63be86840901e17d0f43117e',
    playerId: '1967',
    teamId: 7,
    firstName: 'Henry Nicholls',
    lastName: '',
    middleName: '',
    shortName: 'HM Nicholls',
    title: 'Henry Nicholls',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 2,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 32
  },
  {
    id: '63be86fe0901e17d0f433064',
    matchId: '63be86840901e17d0f43117e',
    playerId: '31',
    teamId: 7,
    firstName: 'Kane Williamson',
    lastName: '',
    middleName: '',
    shortName: 'Kane Williamson',
    title: 'Kane Williamson',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 9,
    run: 53,
    boundary: 2,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 77.94,
    points: 71
  },
  {
    id: '63be86fe0901e17d0f433074',
    matchId: '63be86840901e17d0f43117e',
    playerId: '43',
    teamId: 7,
    firstName: 'Tim Southee',
    lastName: '',
    middleName: '',
    shortName: 'Tim Southee',
    title: 'Tim Southee',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 3,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 5.6,
    strikeRate: 0,
    points: 87
  },
  {
    id: '63be86fe0901e17d0f433096',
    matchId: '63be86840901e17d0f43117e',
    playerId: '43370',
    teamId: 13,
    firstName: 'Fakhar Zaman',
    lastName: '',
    middleName: '',
    shortName: 'FK Zaman',
    title: 'Fakhar Zaman',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8.5,
    run: 101,
    boundary: 10,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 1,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 82.79,
    points: 125
  },
  {
    id: '63be86fe0901e17d0f433094',
    matchId: '63be86840901e17d0f43117e',
    playerId: '43371',
    teamId: 13,
    firstName: 'Babar Azam',
    lastName: '',
    middleName: '',
    shortName: 'Babar Azam',
    title: 'Babar Azam',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 9,
    run: 4,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 30.77,
    points: 9
  },
  {
    id: '63be86fe0901e17d0f43307f',
    matchId: '63be86840901e17d0f43117e',
    playerId: '44054',
    teamId: 13,
    firstName: 'Mohammad Rizwan',
    lastName: '',
    middleName: '',
    shortName: 'Mohammad Rizwan',
    title: 'Mohammad Rizwan',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8.5,
    run: 77,
    boundary: 6,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 1,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 104.05,
    points: 99
  },
  {
    id: '63be86fe0901e17d0f4330a0',
    matchId: '63be86840901e17d0f43117e',
    playerId: '44070',
    teamId: 13,
    firstName: 'Usama Mir',
    lastName: '',
    middleName: '',
    shortName: 'Usama Mir',
    title: 'Usama Mir',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8,
    run: 6,
    boundary: 0,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 6.1,
    strikeRate: 0,
    points: 53
  },
  {
    id: '63be86fe0901e17d0f433098',
    matchId: '63be86840901e17d0f43117e',
    playerId: '44075',
    teamId: 13,
    firstName: 'Kamran Ghulam',
    lastName: '',
    middleName: '',
    shortName: 'Kamran Ghulam',
    title: 'Kamran Ghulam',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63be86fe0901e17d0f433060',
    matchId: '63be86840901e17d0f43117e',
    playerId: '44185',
    teamId: 7,
    firstName: 'Tom Latham',
    lastName: '',
    middleName: '',
    shortName: 'Tom Latham',
    title: 'Tom Latham',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 9,
    run: 16,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 1,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 72.73,
    points: 41
  },
  {
    id: '63be86fe0901e17d0f433097',
    matchId: '63be86840901e17d0f43117e',
    playerId: '45199',
    teamId: 13,
    firstName: 'Imam ul Haq',
    lastName: '',
    middleName: '',
    shortName: 'IU Haq',
    title: 'Imam ul Haq',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63be86fe0901e17d0f433099',
    matchId: '63be86840901e17d0f43117e',
    playerId: '45391',
    teamId: 13,
    firstName: 'Tayyab Tahir',
    lastName: '',
    middleName: '',
    shortName: 'Tayyab Tahir',
    title: 'Tayyab Tahir',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 1,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 12
  },
  {
    id: '63be86fe0901e17d0f43309c',
    matchId: '63be86840901e17d0f43117e',
    playerId: '45397',
    teamId: 13,
    firstName: 'Agha Salman',
    lastName: '',
    middleName: '',
    shortName: 'Agha Salman',
    title: 'Agha Salman',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8,
    run: 45,
    boundary: 4,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 4.3,
    strikeRate: 104.65,
    points: 117
  },
  {
    id: '63be86fe0901e17d0f433069',
    matchId: '63be86840901e17d0f43117e',
    playerId: '46141',
    teamId: 7,
    firstName: 'Devon Conway',
    lastName: '',
    middleName: '',
    shortName: 'Devon Conway',
    title: 'Devon Conway',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 52,
    boundary: 5,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 80,
    points: 67
  },
  {
    id: '63be86fe0901e17d0f433079',
    matchId: '63be86840901e17d0f43117e',
    playerId: '46310',
    teamId: 7,
    firstName: 'Blair Tickner',
    lastName: '',
    middleName: '',
    shortName: 'BM Tickner',
    title: 'Blair Tickner',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63be86fe0901e17d0f43309a',
    matchId: '63be86840901e17d0f43117e',
    playerId: '49076',
    teamId: 13,
    firstName: 'Shan Masood',
    lastName: '',
    middleName: '',
    shortName: 'Shan Masood',
    title: 'Shan Masood',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 1,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 9
  },
  {
    id: '63be86fe0901e17d0f43307b',
    matchId: '63be86840901e17d0f43117e',
    playerId: '49103',
    teamId: 7,
    firstName: 'Doug Bracewell',
    lastName: '',
    middleName: '',
    shortName: 'DAJ Bracewell',
    title: 'Doug Bracewell',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 8
  },
  {
    id: '63be86fe0901e17d0f43309e',
    matchId: '63be86840901e17d0f43117e',
    playerId: '58152',
    teamId: 13,
    firstName: 'Mohammad Wasim',
    lastName: '',
    middleName: '',
    shortName: 'Mohammad Wasim',
    title: 'Mohammad Wasim',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8.5,
    run: 7,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 1,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 7,
    strikeRate: 0,
    points: 73
  },
  {
    id: '63be86fe0901e17d0f43307d',
    matchId: '63be86840901e17d0f43117e',
    playerId: '90808',
    teamId: 7,
    firstName: 'Henry Shipley',
    lastName: '',
    middleName: '',
    shortName: 'HB Shipley',
    title: 'Henry Shipley',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63be86fe0901e17d0f4330a1',
    matchId: '63be86840901e17d0f43117e',
    playerId: '91267',
    teamId: 13,
    firstName: 'Shahnawaz Dahani',
    lastName: '',
    middleName: '',
    shortName: 'Shahnawaz Dahani',
    title: 'Shahnawaz Dahani',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63be86fe0901e17d0f43309d',
    matchId: '63be86840901e17d0f43117e',
    playerId: '92381',
    teamId: 13,
    firstName: 'Haris Rauf',
    lastName: '',
    middleName: '',
    shortName: 'Haris Rauf',
    title: 'Haris Rauf',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 9,
    run: 1,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 5.86,
    strikeRate: 0,
    points: 5
  },
  {
    id: '63be86fe0901e17d0f4330a2',
    matchId: '63be86840901e17d0f43117e',
    playerId: '94150',
    teamId: 13,
    firstName: 'Mohammad Hasnain',
    lastName: '',
    middleName: '',
    shortName: 'M Hasnain',
    title: 'Mohammad Hasnain',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8,
    run: 4,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 6.81,
    strikeRate: 0,
    points: 9
  },
  {
    id: '63be86fe0901e17d0f43309f',
    matchId: '63be86840901e17d0f43117e',
    playerId: '95413',
    teamId: 13,
    firstName: 'Naseem Shah',
    lastName: '',
    middleName: '',
    shortName: 'Naseem Shah',
    title: 'Naseem Shah',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Pakistan',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  }
];
export const wiVsEngPlayerList = [
  {
    id: '622ae1b082f394e16728de07',
    matchId: '622ae1a182f394e16728d732',
    playerId: '1211',
    teamId: 17,
    firstName: 'Alzarri Joseph',
    lastName: '',
    middleName: '',
    shortName: 'Alzarri Joseph',
    title: 'Alzarri Joseph',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8.5,
    run: 19,
    boundary: 2,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 2,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 75
  },
  {
    id: '622ae1b082f394e16728ddf8',
    matchId: '622ae1a182f394e16728d732',
    playerId: '271',
    teamId: 17,
    firstName: 'Jason Holder',
    lastName: '',
    middleName: '',
    shortName: 'Jason Holder',
    title: 'Jason Holder',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 10,
    run: 12,
    boundary: 2,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 1,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 30
  },
  {
    id: '622ae1b082f394e16728de00',
    matchId: '622ae1a182f394e16728d732',
    playerId: '273',
    teamId: 17,
    firstName: 'Kemar Roach',
    lastName: '',
    middleName: '',
    shortName: 'Kemar Roach',
    title: 'Kemar Roach',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 9,
    run: 1,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 61
  },
  {
    id: '622ae1b082f394e16728dded',
    matchId: '622ae1a182f394e16728d732',
    playerId: '46941',
    teamId: 17,
    firstName: 'Jermaine Blackwood',
    lastName: '',
    middleName: '',
    shortName: 'Jermaine Blackwood',
    title: 'Jermaine Blackwood',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8.5,
    run: 27,
    boundary: 2,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 1,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 154
  },
  {
    id: '622ae1b082f394e16728dde5',
    matchId: '622ae1a182f394e16728d732',
    playerId: '49048',
    teamId: 17,
    firstName: 'Kraigg Brathwaite',
    lastName: '',
    middleName: '',
    shortName: 'Kraigg Brathwaite',
    title: 'Kraigg Brathwaite',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 9,
    run: 56,
    boundary: 4,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 1,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 285
  },
  {
    id: '622ae1b082f394e16728de0a',
    matchId: '622ae1a182f394e16728d732',
    playerId: '49056',
    teamId: 17,
    firstName: 'Veerasammy Permaul',
    lastName: '',
    middleName: '',
    shortName: 'V Permaul',
    title: 'Veerasammy Permaul',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8.5,
    run: 5,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 89
  },
  {
    id: '622ae1b082f394e16728ddfb',
    matchId: '622ae1a182f394e16728d732',
    playerId: '50088',
    teamId: 17,
    firstName: 'Kyle Mayers',
    lastName: '',
    middleName: '',
    shortName: 'Kyle Mayers',
    title: 'Kyle Mayers',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '622ae1b082f394e16728dde9',
    matchId: '622ae1a182f394e16728d732',
    playerId: '50132',
    teamId: 17,
    firstName: 'Nkrumah Bonner',
    lastName: '',
    middleName: '',
    shortName: 'Nkrumah Bonner',
    title: 'Nkrumah Bonner',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 9,
    run: 3,
    boundary: 2,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 26
  },
  {
    id: '622ae1b082f394e16728de11',
    matchId: '622ae1a182f394e16728d732',
    playerId: '52207',
    teamId: 17,
    firstName: 'Anderson Phillip',
    lastName: '',
    middleName: '',
    shortName: 'A Phillip',
    title: 'Anderson Phillip',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '622ae1b082f394e16728ddf0',
    matchId: '622ae1a182f394e16728d732',
    playerId: '53729',
    teamId: 17,
    firstName: 'John Campbell',
    lastName: '',
    middleName: '',
    shortName: 'John Campbell',
    title: 'John Campbell',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8.5,
    run: 10,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 28
  },
  {
    id: '622ae1b082f394e16728ddf6',
    matchId: '622ae1a182f394e16728d732',
    playerId: '53768',
    teamId: 17,
    firstName: 'Shamarh Brooks',
    lastName: '',
    middleName: '',
    shortName: 'Shamarh Brooks',
    title: 'Shamarh Brooks',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8.5,
    run: 4,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 61
  },
  {
    id: '622ae1b082f394e16728dde4',
    matchId: '622ae1a182f394e16728d732',
    playerId: '94754',
    teamId: 17,
    firstName: 'Joshua Da Silva',
    lastName: '',
    middleName: '',
    shortName: 'J Da Silva',
    title: 'Joshua Da Silva',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8.5,
    run: 30,
    boundary: 6,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 2,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 108
  },
  {
    id: '622ae1b082f394e16728de03',
    matchId: '622ae1a182f394e16728d732',
    playerId: '96398',
    teamId: 17,
    firstName: 'Jayden Seales',
    lastName: '',
    middleName: '',
    shortName: 'Jayden Seales',
    title: 'Jayden Seales',
    playingEleven: true,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 9,
    run: 5,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 74
  },
  {
    id: '622ae1b082f394e16728de24',
    matchId: '622ae1a182f394e16728d732',
    playerId: '1042',
    teamId: 490,
    firstName: 'Dan Lawrence',
    lastName: '',
    middleName: '',
    shortName: 'DW Lawrence',
    title: 'Dan Lawrence',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 41,
    boundary: 1,
    six: 2,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 192
  },
  {
    id: '622ae1b082f394e16728de31',
    matchId: '622ae1a182f394e16728d732',
    playerId: '1052',
    teamId: 490,
    firstName: 'Saqib Mahmood',
    lastName: '',
    middleName: '',
    shortName: 'S Mahmood',
    title: 'Saqib Mahmood',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 68
  },
  {
    id: '622ae1b082f394e16728de1b',
    matchId: '622ae1a182f394e16728d732',
    playerId: '10598',
    teamId: 490,
    firstName: 'Ben Foakes',
    lastName: '',
    middleName: '',
    shortName: 'BT Foakes',
    title: 'Ben Foakes',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 11,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 57
  },
  {
    id: '622ae1b082f394e16728de28',
    matchId: '622ae1a182f394e16728d732',
    playerId: '10612',
    teamId: 490,
    firstName: 'Alex Lees',
    lastName: '',
    middleName: '',
    shortName: 'AZ Lees',
    title: 'Alex Lees',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 24,
    boundary: 2,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 71
  },
  {
    id: '622ae1b082f394e16728de2c',
    matchId: '622ae1a182f394e16728d732',
    playerId: '107',
    teamId: 490,
    firstName: 'Chris Woakes',
    lastName: '',
    middleName: '',
    shortName: 'Chris Woakes',
    title: 'Chris Woakes',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 9,
    boundary: 3,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 83
  },
  {
    id: '622ae1b082f394e16728de2a',
    matchId: '622ae1a182f394e16728d732',
    playerId: '1931',
    teamId: 490,
    firstName: 'Ben Stokes',
    lastName: '',
    middleName: '',
    shortName: 'Ben Stokes',
    title: 'Ben Stokes',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 10,
    run: 19,
    boundary: 1,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 1,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 209
  },
  {
    id: '622ae1b082f394e16728de15',
    matchId: '622ae1a182f394e16728d732',
    playerId: '44100',
    teamId: 490,
    firstName: 'Jonny Bairstow',
    lastName: '',
    middleName: '',
    shortName: 'JM Bairstow',
    title: 'Jonny Bairstow',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 9.5,
    run: 29,
    boundary: 1,
    six: 2,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 69
  },
  {
    id: '622ae1b082f394e16728de2e',
    matchId: '622ae1a182f394e16728d732',
    playerId: '49060',
    teamId: 490,
    firstName: 'Mark Wood',
    lastName: '',
    middleName: '',
    shortName: 'Mark Wood',
    title: 'Mark Wood',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '622ae1b082f394e16728de33',
    matchId: '622ae1a182f394e16728d732',
    playerId: '49425',
    teamId: 490,
    firstName: 'Jack Leach',
    lastName: '',
    middleName: '',
    shortName: 'MJ Leach',
    title: 'Jack Leach',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 4,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 3,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 105
  },
  {
    id: '622ae1b082f394e16728de34',
    matchId: '622ae1a182f394e16728d732',
    playerId: '49733',
    teamId: 490,
    firstName: 'Craig Overton',
    lastName: '',
    middleName: '',
    shortName: 'C Overton',
    title: 'Craig Overton',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '622ae1b082f394e16728de37',
    matchId: '622ae1a182f394e16728d732',
    playerId: '49743',
    teamId: 490,
    firstName: 'Matthew Fisher',
    lastName: '',
    middleName: '',
    shortName: 'MD Fisher',
    title: 'Matthew Fisher',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 28
  },
  {
    id: '622ae1b082f394e16728de23',
    matchId: '622ae1a182f394e16728d732',
    playerId: '50774',
    teamId: 490,
    firstName: 'Zak Crawley',
    lastName: '',
    middleName: '',
    shortName: 'Zak Crawley',
    title: 'Zak Crawley',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 9,
    run: 40,
    boundary: 4,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 1,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 44
  },
  {
    id: '622ae1b082f394e16728de26',
    matchId: '622ae1a182f394e16728d732',
    playerId: '51290',
    teamId: 490,
    firstName: 'Ollie Pope',
    lastName: '',
    middleName: '',
    shortName: 'Ollie Pope',
    title: 'Ollie Pope',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '622ae1b082f394e16728de36',
    matchId: '622ae1a182f394e16728d732',
    playerId: '51308',
    teamId: 490,
    firstName: 'Ollie Robinson',
    lastName: '',
    middleName: '',
    shortName: 'Ollie Robinson',
    title: 'Ollie Robinson',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '622ae1b082f394e16728de38',
    matchId: '622ae1a182f394e16728d732',
    playerId: '93789',
    teamId: 490,
    firstName: 'Matt Parkinson',
    lastName: '',
    middleName: '',
    shortName: 'Matt Parkinson',
    title: 'Matt Parkinson',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '622ae1b082f394e16728de21',
    matchId: '622ae1a182f394e16728d732',
    playerId: '99',
    teamId: 490,
    firstName: 'Joe Root',
    lastName: '',
    middleName: '',
    shortName: 'JE Root',
    title: 'Joe Root',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 10,
    run: 9,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 1,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 2,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 205
  }
];

export const saVsEngPlayerList = [
  {
    id: '63d0da0f96851a4d7f67e849',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '159',
    teamId: 19,
    firstName: 'Quinton de Kock',
    lastName: '',
    middleName: '',
    shortName: 'Quinton de Kock',
    title: 'Quinton de Kock',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e84b',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '167',
    teamId: 19,
    firstName: 'David Miller',
    lastName: '',
    middleName: '',
    shortName: 'David Miller',
    title: 'David Miller',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e84f',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '1953',
    teamId: 19,
    firstName: 'Kagiso Rabada',
    lastName: '',
    middleName: '',
    shortName: 'Kagiso Rabada',
    title: 'Kagiso Rabada',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e84d',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '406',
    teamId: 19,
    firstName: 'Wayne Parnell',
    lastName: '',
    middleName: '',
    shortName: 'Wayne Parnell',
    title: 'Wayne Parnell',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e852',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '46117',
    teamId: 19,
    firstName: 'Aiden Markram',
    lastName: '',
    middleName: '',
    shortName: 'Aiden Markram',
    title: 'Aiden Markram',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e854',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '46124',
    teamId: 19,
    firstName: 'Heinrich Klaasen',
    lastName: '',
    middleName: '',
    shortName: 'Heinrich Klaasen',
    title: 'Heinrich Klaasen',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e856',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '46126',
    teamId: 19,
    firstName: 'Tabraiz Shamsi',
    lastName: '',
    middleName: '',
    shortName: 'Tabraiz Shamsi',
    title: 'Tabraiz Shamsi',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e858',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '46131',
    teamId: 19,
    firstName: 'Lungi Ngidi',
    lastName: '',
    middleName: '',
    shortName: 'Lungi Ngidi',
    title: 'Lungi Ngidi',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e85a',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '46135',
    teamId: 19,
    firstName: 'Rassie van der Dussen',
    lastName: '',
    middleName: '',
    shortName: 'Rassie van der Dussen',
    title: 'Rassie van der Dussen',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e85c',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '46139',
    teamId: 19,
    firstName: 'Temba Bavuma',
    lastName: '',
    middleName: '',
    shortName: 'Temba Bavuma',
    title: 'Temba Bavuma',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e85d',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '49700',
    teamId: 19,
    firstName: 'Reeza Hendricks',
    lastName: '',
    middleName: '',
    shortName: 'Reeza Hendricks',
    title: 'Reeza Hendricks',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e85f',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '49706',
    teamId: 19,
    firstName: 'Keshav Maharaj',
    lastName: '',
    middleName: '',
    shortName: 'Keshav Maharaj',
    title: 'Keshav Maharaj',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e861',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '52975',
    teamId: 19,
    firstName: 'Sisanda Magala',
    lastName: '',
    middleName: '',
    shortName: 'Sisanda Magala',
    title: 'Sisanda Magala',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e863',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '56239',
    teamId: 19,
    firstName: 'Janneman Malan',
    lastName: '',
    middleName: '',
    shortName: 'JN Malan',
    title: 'Janneman Malan',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e866',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '57187',
    teamId: 19,
    firstName: 'Anrich Nortje',
    lastName: '',
    middleName: '',
    shortName: 'Anrich Nortje',
    title: 'Anrich Nortje',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e868',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '60394',
    teamId: 19,
    firstName: 'Marco Jansen',
    lastName: '',
    middleName: '',
    shortName: 'M Jansen',
    title: 'Marco Jansen',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Fast',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e874',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '1047',
    teamId: 490,
    firstName: 'Sam Curran',
    lastName: '',
    middleName: '',
    shortName: 'Sam Curran',
    title: 'Sam Curran',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e870',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '105',
    teamId: 490,
    firstName: 'Jos Buttler',
    lastName: '',
    middleName: '',
    shortName: 'Jos Buttler',
    title: 'Jos Buttler',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e871',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '107',
    teamId: 490,
    firstName: 'Chris Woakes',
    lastName: '',
    middleName: '',
    shortName: 'Chris Woakes',
    title: 'Chris Woakes',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e876',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '1929',
    teamId: 490,
    firstName: 'Jason Roy',
    lastName: '',
    middleName: '',
    shortName: 'Jason Roy',
    title: 'Jason Roy',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e879',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '1933',
    teamId: 490,
    firstName: 'Adil Rashid',
    lastName: '',
    middleName: '',
    shortName: 'Adil Rashid',
    title: 'Adil Rashid',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e87a',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '1935',
    teamId: 490,
    firstName: 'David Willey',
    lastName: '',
    middleName: '',
    shortName: 'DJ Willey',
    title: 'David Willey',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e87c',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '1937',
    teamId: 490,
    firstName: 'Reece Topley',
    lastName: '',
    middleName: '',
    shortName: 'RJW Topley',
    title: 'Reece Topley',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e87d',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '43358',
    teamId: 490,
    firstName: 'Dawid Malan',
    lastName: '',
    middleName: '',
    shortName: 'Dawid Malan',
    title: 'Dawid Malan',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e87f',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '49378',
    teamId: 490,
    firstName: 'Ben Duckett',
    lastName: '',
    middleName: '',
    shortName: 'BM Duckett',
    title: 'Ben Duckett',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e881',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '49382',
    teamId: 490,
    firstName: 'Olly Stone',
    lastName: '',
    middleName: '',
    shortName: 'OP Stone',
    title: 'Olly Stone',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e882',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '49818',
    teamId: 490,
    firstName: 'Philip Salt',
    lastName: '',
    middleName: '',
    shortName: 'PD Salt',
    title: 'Philip Salt',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e884',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '57877',
    teamId: 490,
    firstName: 'Jofra Archer',
    lastName: '',
    middleName: '',
    shortName: 'Jofra Archer',
    title: 'Jofra Archer',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e886',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '90887',
    teamId: 490,
    firstName: 'Harry Brook',
    lastName: '',
    middleName: '',
    shortName: 'Harry Brook',
    title: 'Harry Brook',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d0da0f96851a4d7f67e86a',
    matchId: '63d0d9c596851a4d7f67dcd5',
    playerId: '93',
    teamId: 490,
    firstName: 'Moeen Ali',
    lastName: '',
    middleName: '',
    shortName: 'Moeen Ali',
    title: 'Moeen Ali',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  }
];
export const indVsNzT20PlayerList = [
  {
    id: '63cf7a0996851a4d7f28bea4',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '1082',
    teamId: 7,
    firstName: 'Glenn Phillips',
    lastName: '',
    middleName: '',
    shortName: 'Glenn Phillips',
    title: 'Glenn Phillips',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 79
  },
  {
    id: '63cf7a0996851a4d7f28bea5',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '1083',
    teamId: 7,
    firstName: 'Finn Allen',
    lastName: '',
    middleName: '',
    shortName: 'Finn Allen',
    title: 'Finn Allen',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 65
  },
  {
    id: '63cf7a0996851a4d7f28bea9',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '16509',
    teamId: 7,
    firstName: 'Daryl Mitchell',
    lastName: '',
    middleName: '',
    shortName: 'DJ Mitchell',
    title: 'Daryl Mitchell',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 122
  },
  {
    id: '63cf7a0996851a4d7f28beaa',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '16557',
    teamId: 7,
    firstName: 'Michael Bracewell',
    lastName: '',
    middleName: '',
    shortName: 'Michael Bracewell',
    title: 'Michael Bracewell',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 284
  },
  {
    id: '63cf7a0996851a4d7f28beab',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '16566',
    teamId: 7,
    firstName: 'Jacob Duffy',
    lastName: '',
    middleName: '',
    shortName: 'JA Duffy',
    title: 'Jacob Duffy',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 73
  },
  {
    id: '63cf7a0996851a4d7f28beac',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '16611',
    teamId: 7,
    firstName: 'Dane Cleaver',
    lastName: '',
    middleName: '',
    shortName: 'D Cleaver',
    title: 'Dane Cleaver',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63cf7a0996851a4d7f28bead',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '16643',
    teamId: 7,
    firstName: 'Lockie Ferguson',
    lastName: '',
    middleName: '',
    shortName: 'LH Ferguson',
    title: 'Lockie Ferguson',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 64
  },
  {
    id: '63cf7a0996851a4d7f28bea6',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '1708',
    teamId: 7,
    firstName: 'Mark Chapman',
    lastName: '',
    middleName: '',
    shortName: 'MS Chapman',
    title: 'Mark Chapman',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cf7a0996851a4d7f28bea7',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '1923',
    teamId: 7,
    firstName: 'Mitchell Santner',
    lastName: '',
    middleName: '',
    shortName: 'Mitchell Santner',
    title: 'Mitchell Santner',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 231
  },
  {
    id: '63cf7a0996851a4d7f28bea8',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '1927',
    teamId: 7,
    firstName: 'Ish Sodhi',
    lastName: '',
    middleName: '',
    shortName: 'Ish Sodhi',
    title: 'Ish Sodhi',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cf7a0996851a4d7f28beae',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '46141',
    teamId: 7,
    firstName: 'Devon Conway',
    lastName: '',
    middleName: '',
    shortName: 'Devon Conway',
    title: 'Devon Conway',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 238
  },
  {
    id: '63cf7a0996851a4d7f28beaf',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '46310',
    teamId: 7,
    firstName: 'Blair Tickner',
    lastName: '',
    middleName: '',
    shortName: 'BM Tickner',
    title: 'Blair Tickner',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 113
  },
  {
    id: '63cf7a0996851a4d7f28beb0',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '48327',
    teamId: 7,
    firstName: 'Michael Rippon',
    lastName: '',
    middleName: '',
    shortName: 'Michael Rippon',
    title: 'Michael Rippon',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63cf7a0996851a4d7f28beb1',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '90808',
    teamId: 7,
    firstName: 'Henry Shipley',
    lastName: '',
    middleName: '',
    shortName: 'HB Shipley',
    title: 'Henry Shipley',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 97
  },
  {
    id: '63cf7a0996851a4d7f28beb2',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '93377',
    teamId: 7,
    firstName: 'Ben Lister',
    lastName: '',
    middleName: '',
    shortName: 'BG Lister',
    title: 'Ben Lister',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63cf7a0996851a4d7f28bec2',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '104934',
    teamId: 25,
    firstName: 'Umran Malik',
    lastName: '',
    middleName: '',
    shortName: 'Umran Malik',
    title: 'Umran Malik',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 29
  },
  {
    id: '63cf7a0996851a4d7f28beb8',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '1097',
    teamId: 25,
    firstName: 'Ishan Kishan',
    lastName: '',
    middleName: '',
    shortName: 'Ishan Kishan',
    title: 'Ishan Kishan',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 75
  },
  {
    id: '63cf7a0996851a4d7f28beb9',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '1101',
    teamId: 25,
    firstName: 'Washington Sundar',
    lastName: '',
    middleName: '',
    shortName: 'Washington Sundar',
    title: 'Washington Sundar',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 90
  },
  {
    id: '63cf7a0996851a4d7f28beba',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '54129',
    teamId: 25,
    firstName: 'Rahul Tripathi',
    lastName: '',
    middleName: '',
    shortName: 'RA Tripathi',
    title: 'Rahul Tripathi',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63cf7a0996851a4d7f28bebb',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '55210',
    teamId: 25,
    firstName: 'Jitesh Sharma',
    lastName: '',
    middleName: '',
    shortName: 'JM Sharma',
    title: 'Jitesh Sharma',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63cf7a0996851a4d7f28beb3',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '598',
    teamId: 25,
    firstName: 'Suryakumar Yadav',
    lastName: '',
    middleName: '',
    shortName: 'SA Yadav',
    title: 'Suryakumar Yadav',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 91
  },
  {
    id: '63cf7a0996851a4d7f28beb4',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '641',
    teamId: 25,
    firstName: 'Deepak Hooda',
    lastName: '',
    middleName: '',
    shortName: 'Deepak Hooda',
    title: 'Deepak Hooda',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63cf7a0996851a4d7f28beb5',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '654',
    teamId: 25,
    firstName: 'Yuzvendra Chahal',
    lastName: '',
    middleName: '',
    shortName: 'Yuzvendra Chahal',
    title: 'Yuzvendra Chahal',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 62
  },
  {
    id: '63cf7a0996851a4d7f28beb6',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '727',
    teamId: 25,
    firstName: 'Hardik Pandya',
    lastName: '',
    middleName: '',
    shortName: 'HH Pandya',
    title: 'Hardik Pandya',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 258
  },
  {
    id: '63cf7a0996851a4d7f28beb7',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '775',
    teamId: 25,
    firstName: 'Kuldeep Yadav',
    lastName: '',
    middleName: '',
    shortName: 'KL Yadav',
    title: 'Kuldeep Yadav',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Wrist Spin',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 216
  },
  {
    id: '63cf7a0996851a4d7f28bebc',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '90363',
    teamId: 25,
    firstName: 'Ruturaj Gaikwad',
    lastName: '',
    middleName: '',
    shortName: 'RD Gaikwad',
    title: 'Ruturaj Gaikwad',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63cf7a0996851a4d7f28bebd',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '90493',
    teamId: 25,
    firstName: 'Mukesh Kumar',
    lastName: '',
    middleName: '',
    shortName: 'Mukesh Kumar',
    title: 'Mukesh Kumar',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63cf7a0996851a4d7f28bebe',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '90624',
    teamId: 25,
    firstName: 'Prithvi Shaw',
    lastName: '',
    middleName: '',
    shortName: 'P Shaw',
    title: 'Prithvi Shaw',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63cf7a0996851a4d7f28bebf',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '90739',
    teamId: 25,
    firstName: 'Shubman Gill',
    lastName: '',
    middleName: '',
    shortName: 'Shubman Gill',
    title: 'Shubman Gill',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 488
  },
  {
    id: '63cf7a0996851a4d7f28bec0',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '93497',
    teamId: 25,
    firstName: 'Arshdeep Singh',
    lastName: '',
    middleName: '',
    shortName: 'Arshdeep Singh',
    title: 'Arshdeep Singh',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63cf7a0996851a4d7f28bec1',
    matchId: '63cf79bd96851a4d7f28b245',
    playerId: '93500',
    teamId: 25,
    firstName: 'Shivam Mavi',
    lastName: '',
    middleName: '',
    shortName: 'Shivam Mavi',
    title: 'Shivam Mavi',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  }
];
export const indVsSlTestPlayerList = [
  {
    id: '6225784a17d940379f6d6a8a',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '1137',
    teamId: 21,
    firstName: 'Charith Asalanka',
    lastName: '',
    middleName: '',
    shortName: 'C Asalanka',
    title: 'Charith Asalanka',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8,
    run: 5,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 16
  },
  {
    id: '6225784a17d940379f6d6aa9',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '1142',
    teamId: 21,
    firstName: 'Lahiru Kumara',
    lastName: '',
    middleName: '',
    shortName: 'L Kumara',
    title: 'Lahiru Kumara',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6225784a17d940379f6d6a77',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '1763',
    teamId: 21,
    firstName: 'Niroshan Dickwella',
    lastName: '',
    middleName: '',
    shortName: 'N Dickwella',
    title: 'Niroshan Dickwella',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 12,
    boundary: 3,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 1,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 1,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 80
  },
  {
    id: '6225784a17d940379f6d6ab6',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '1765',
    teamId: 21,
    firstName: 'Jeffrey Vandersay',
    lastName: '',
    middleName: '',
    shortName: 'JF Vandersay',
    title: 'Jeffrey Vandersay',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6225784a17d940379f6d6a74',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '426',
    teamId: 21,
    firstName: 'Dinesh Chandimal',
    lastName: '',
    middleName: '',
    shortName: 'D Chandimal',
    title: 'Dinesh Chandimal',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6225784a17d940379f6d6a92',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '43745',
    teamId: 21,
    firstName: 'Dhananjaya de Silva',
    lastName: '',
    middleName: '',
    shortName: 'D de Silva',
    title: 'Dhananjaya de Silva',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 9,
    run: 4,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 91
  },
  {
    id: '6225784a17d940379f6d6a97',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '43761',
    teamId: 21,
    firstName: 'Chamika Karunaratne',
    lastName: '',
    middleName: '',
    shortName: 'C Karunaratne',
    title: 'Chamika Karunaratne',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6225784a17d940379f6d6a86',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '43953',
    teamId: 21,
    firstName: 'Kusal Mendis',
    lastName: '',
    middleName: '',
    shortName: 'K Mendis',
    title: 'Kusal Mendis',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 54,
    boundary: 8,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 72
  },
  {
    id: '6225784a17d940379f6d6aad',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '43985',
    teamId: 21,
    firstName: 'Vishwa Fernando',
    lastName: '',
    middleName: '',
    shortName: 'MVT Fernando',
    title: 'Vishwa Fernando',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 2,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 31
  },
  {
    id: '6225784a17d940379f6d6aa4',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '462',
    teamId: 21,
    firstName: 'Dushmantha Chameera',
    lastName: '',
    middleName: '',
    shortName: 'D Chameera',
    title: 'Dushmantha Chameera',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6225784a17d940379f6d6a80',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '49',
    teamId: 21,
    firstName: 'Lahiru Thirimanne',
    lastName: '',
    middleName: '',
    shortName: 'L Thirimanne',
    title: 'Lahiru Thirimanne',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 8,
    boundary: 2,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 1,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 18
  },
  {
    id: '6225784a17d940379f6d6ab1',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '56049',
    teamId: 21,
    firstName: 'Lasith Embuldeniya',
    lastName: '',
    middleName: '',
    shortName: 'L Embuldeniya',
    title: 'Lasith Embuldeniya',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 2,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 3,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 103
  },
  {
    id: '6225784a17d940379f6d6a79',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '57',
    teamId: 21,
    firstName: 'Dimuth Karunaratne',
    lastName: '',
    middleName: '',
    shortName: 'D Karunaratne',
    title: 'Dimuth Karunaratne',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 9.5,
    run: 107,
    boundary: 15,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 1,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 139
  },
  {
    id: '6225784a17d940379f6d6a8d',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '59',
    teamId: 21,
    firstName: 'Angelo Mathews',
    lastName: '',
    middleName: '',
    shortName: 'A Mathews',
    title: 'Angelo Mathews',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 9,
    run: 1,
    boundary: 3,
    six: 2,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 63
  },
  {
    id: '6225784a17d940379f6d6a9c',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '69',
    teamId: 21,
    firstName: 'Suranga Lakmal',
    lastName: '',
    middleName: '',
    shortName: 'S Lakmal',
    title: 'Suranga Lakmal',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 1,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 27
  },
  {
    id: '6225784a17d940379f6d6a7c',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '84107',
    teamId: 21,
    firstName: 'Pathum Nissanka',
    lastName: '',
    middleName: '',
    shortName: 'Pathum Nissanka',
    title: 'Pathum Nissanka',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6225784a17d940379f6d6ab5',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '90785',
    teamId: 21,
    firstName: 'Praveen Jayawickrama',
    lastName: '',
    middleName: '',
    shortName: 'P Jayawickrama',
    title: 'Praveen Jayawickrama',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 1,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 4,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 1,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 1,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 137
  },
  {
    id: '6225784a17d940379f6d6ab8',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '1098',
    teamId: 25,
    firstName: 'Rishabh Pant',
    lastName: '',
    middleName: '',
    shortName: 'Rishabh Pant',
    title: 'Rishabh Pant',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 50,
    boundary: 7,
    six: 2,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 2,
    stump: 2,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 167
  },
  {
    id: '6225784a17d940379f6d6ac5',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '115',
    teamId: 25,
    firstName: 'Rohit Sharma',
    lastName: '',
    middleName: '',
    shortName: 'Rohit Sharma',
    title: 'Rohit Sharma',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9.5,
    run: 46,
    boundary: 4,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 88
  },
  {
    id: '6225784a17d940379f6d6ac2',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '119',
    teamId: 25,
    firstName: 'Virat Kohli',
    lastName: '',
    middleName: '',
    shortName: 'Virat Kohli',
    title: 'Virat Kohli',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 10,
    run: 13,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 43
  },
  {
    id: '6225784a17d940379f6d6adc',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '125',
    teamId: 25,
    firstName: 'Ravindra Jadeja',
    lastName: '',
    middleName: '',
    shortName: 'RA Jadeja',
    title: 'Ravindra Jadeja',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 10,
    run: 22,
    boundary: 3,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 50
  },
  {
    id: '6225784a17d940379f6d6adf',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '129',
    teamId: 25,
    firstName: 'Ravichandran Ashwin',
    lastName: '',
    middleName: '',
    shortName: 'Ravichandran Ashwin',
    title: 'Ravichandran Ashwin',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9.5,
    run: 13,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 4,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 1,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 140
  },
  {
    id: '6225784a17d940379f6d6aeb',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '131',
    teamId: 25,
    firstName: 'Mohammed Shami',
    lastName: '',
    middleName: '',
    shortName: 'M Shami',
    title: 'Mohammed Shami',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 16,
    boundary: 2,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 70
  },
  {
    id: '6225784a17d940379f6d6af4',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '133',
    teamId: 25,
    firstName: 'Umesh Yadav',
    lastName: '',
    middleName: '',
    shortName: 'UT Yadav',
    title: 'Umesh Yadav',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6225784a17d940379f6d6ada',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '53825',
    teamId: 25,
    firstName: 'Priyank Panchal',
    lastName: '',
    middleName: '',
    shortName: 'Priyank Panchal',
    title: 'Priyank Panchal',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6225784a17d940379f6d6ae8',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '53840',
    teamId: 25,
    firstName: 'Saurabh Kumar',
    lastName: '',
    middleName: '',
    shortName: 'Saurabh Kumar',
    title: 'Saurabh Kumar',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6225784a17d940379f6d6abc',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '53855',
    teamId: 25,
    firstName: 'Srikar Bharat',
    lastName: '',
    middleName: '',
    shortName: 'KS Bharat',
    title: 'Srikar Bharat',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6225784a17d940379f6d6aef',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '607',
    teamId: 25,
    firstName: 'Jasprit Bumrah',
    lastName: '',
    middleName: '',
    shortName: 'JJ Bumrah',
    title: 'Jasprit Bumrah',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 3,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 1,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 140
  },
  {
    id: '6225784a17d940379f6d6aca',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '617',
    teamId: 25,
    firstName: 'Mayank Agarwal',
    lastName: '',
    middleName: '',
    shortName: 'Mayank Agarwal',
    title: 'Mayank Agarwal',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 22,
    boundary: 5,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 36
  },
  {
    id: '6225784a17d940379f6d6ace',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '620',
    teamId: 25,
    firstName: 'Shreyas Iyer',
    lastName: '',
    middleName: '',
    shortName: 'S Iyer',
    title: 'Shreyas Iyer',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 67,
    boundary: 9,
    six: 4,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 2,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 214
  },
  {
    id: '6225eae917d940379f82819a',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '634',
    teamId: 25,
    firstName: 'Axar Patel',
    lastName: '',
    middleName: '',
    shortName: 'Axar Patel',
    title: 'Axar Patel',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 9,
    boundary: 1,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 73
  },
  {
    id: '6225784a17d940379f6d6ad0',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '764',
    teamId: 25,
    firstName: 'Hanuma Vihari',
    lastName: '',
    middleName: '',
    shortName: 'GH Vihari',
    title: 'Hanuma Vihari',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 35,
    boundary: 4,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 86
  },
  {
    id: '6225784a17d940379f6d6af5',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '775',
    teamId: 25,
    firstName: 'Kuldeep Yadav',
    lastName: '',
    middleName: '',
    shortName: 'KL Yadav',
    title: 'Kuldeep Yadav',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Wrist Spin',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6225784a17d940379f6d6ae4',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '851',
    teamId: 25,
    firstName: 'Jayant Yadav',
    lastName: '',
    middleName: '',
    shortName: 'J Yadav',
    title: 'Jayant Yadav',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6225784a17d940379f6d6af8',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '90381',
    teamId: 25,
    firstName: 'Mohammed Siraj',
    lastName: '',
    middleName: '',
    shortName: 'Mohammed Siraj',
    title: 'Mohammed Siraj',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6225784a17d940379f6d6ad7',
    matchId: '6225783d17d940379f6d67d1',
    playerId: '90739',
    teamId: 25,
    firstName: 'Shubman Gill',
    lastName: '',
    middleName: '',
    shortName: 'Shubman Gill',
    title: 'Shubman Gill',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  }
];
export const indVsSaT20PlayerList = [
  {
    id: '63345055258445b807483a57',
    matchId: '63344fdc258445b807480bf7',
    playerId: '1098',
    teamId: 25,
    firstName: 'Rishabh Pant',
    lastName: '',
    middleName: '',
    shortName: 'Rishabh Pant',
    title: 'Rishabh Pant',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 4
  },
  {
    id: '63345055258445b807483a59',
    matchId: '63344fdc258445b807480bf7',
    playerId: '115',
    teamId: 25,
    firstName: 'Rohit Sharma',
    lastName: '',
    middleName: '',
    shortName: 'Rohit Sharma',
    title: 'Rohit Sharma',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 43,
    boundary: 7,
    six: 1,
    thirtyRuns: 1,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 116.22,
    points: 60
  },
  {
    id: '63345055258445b807483a5e',
    matchId: '63344fdc258445b807480bf7',
    playerId: '119',
    teamId: 25,
    firstName: 'Virat Kohli',
    lastName: '',
    middleName: '',
    shortName: 'Virat Kohli',
    title: 'Virat Kohli',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 49,
    boundary: 7,
    six: 1,
    thirtyRuns: 1,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 175,
    points: 80
  },
  {
    id: '63345055258445b807483a76',
    matchId: '63344fdc258445b807480bf7',
    playerId: '129',
    teamId: 25,
    firstName: 'Ravichandran Ashwin',
    lastName: '',
    middleName: '',
    shortName: 'Ravichandran Ashwin',
    title: 'Ravichandran Ashwin',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 9.25,
    strikeRate: 0,
    points: 4
  },
  {
    id: '63345055258445b807483a7b',
    matchId: '63344fdc258445b807480bf7',
    playerId: '133',
    teamId: 25,
    firstName: 'Umesh Yadav',
    lastName: '',
    middleName: '',
    shortName: 'UT Yadav',
    title: 'Umesh Yadav',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63345055258445b807483a32',
    matchId: '63344fdc258445b807480bf7',
    playerId: '159',
    teamId: 19,
    firstName: 'Quinton de Kock',
    lastName: '',
    middleName: '',
    shortName: 'Quinton de Kock',
    title: 'Quinton de Kock',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 9,
    run: 69,
    boundary: 3,
    six: 4,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 143.75,
    points: 94
  },
  {
    id: '63345055258445b807483a35',
    matchId: '63344fdc258445b807480bf7',
    playerId: '167',
    teamId: 19,
    firstName: 'David Miller',
    lastName: '',
    middleName: '',
    shortName: 'David Miller',
    title: 'David Miller',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 106,
    boundary: 8,
    six: 7,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 1,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 225.53,
    points: 154
  },
  {
    id: '63345055258445b807483a49',
    matchId: '63344fdc258445b807480bf7',
    playerId: '1953',
    teamId: 19,
    firstName: 'Kagiso Rabada',
    lastName: '',
    middleName: '',
    shortName: 'Kagiso Rabada',
    title: 'Kagiso Rabada',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 14.25,
    strikeRate: 0,
    points: -2
  },
  {
    id: '63345055258445b807483a46',
    matchId: '63344fdc258445b807480bf7',
    playerId: '406',
    teamId: 19,
    firstName: 'Wayne Parnell',
    lastName: '',
    middleName: '',
    shortName: 'Wayne Parnell',
    title: 'Wayne Parnell',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 13.5,
    strikeRate: 0,
    points: -2
  },
  {
    id: '63345055258445b807483a3c',
    matchId: '63344fdc258445b807480bf7',
    playerId: '430',
    teamId: 19,
    firstName: 'Rilee Rossouw',
    lastName: '',
    middleName: '',
    shortName: 'Rilee Rossouw',
    title: 'Rilee Rossouw',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 1,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 2
  },
  {
    id: '63345055258445b807483a40',
    matchId: '63344fdc258445b807480bf7',
    playerId: '46117',
    teamId: 19,
    firstName: 'Aiden Markram',
    lastName: '',
    middleName: '',
    shortName: 'Aiden Markram',
    title: 'Aiden Markram',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 9,
    run: 33,
    boundary: 4,
    six: 1,
    thirtyRuns: 1,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 9,
    strikeRate: 173.68,
    points: 53
  },
  {
    id: '63345055258445b807483a33',
    matchId: '63344fdc258445b807480bf7',
    playerId: '46124',
    teamId: 19,
    firstName: 'Heinrich Klaasen',
    lastName: '',
    middleName: '',
    shortName: 'Heinrich Klaasen',
    title: 'Heinrich Klaasen',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63345055258445b807483a4c',
    matchId: '63344fdc258445b807480bf7',
    playerId: '46126',
    teamId: 19,
    firstName: 'Tabraiz Shamsi',
    lastName: '',
    middleName: '',
    shortName: 'Tabraiz Shamsi',
    title: 'Tabraiz Shamsi',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63345055258445b807483a4d',
    matchId: '63344fdc258445b807480bf7',
    playerId: '46131',
    teamId: 19,
    firstName: 'Lungi Ngidi',
    lastName: '',
    middleName: '',
    shortName: 'Lungi Ngidi',
    title: 'Lungi Ngidi',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 12.25,
    strikeRate: 0,
    points: -2
  },
  {
    id: '63345055258445b807483a3e',
    matchId: '63344fdc258445b807480bf7',
    playerId: '46139',
    teamId: 19,
    firstName: 'Temba Bavuma',
    lastName: '',
    middleName: '',
    shortName: 'Temba Bavuma',
    title: 'Temba Bavuma',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 1,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 1,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 8
  },
  {
    id: '63354ded258445b8077c9d53',
    matchId: '63344fdc258445b807480bf7',
    playerId: '46147',
    teamId: 19,
    firstName: 'Bjorn Fortuin',
    lastName: '',
    middleName: '',
    shortName: 'Bjorn Fortuin',
    title: 'Bjorn Fortuin',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63345055258445b807483a38',
    matchId: '63344fdc258445b807480bf7',
    playerId: '49700',
    teamId: 19,
    firstName: 'Reeza Hendricks',
    lastName: '',
    middleName: '',
    shortName: 'Reeza Hendricks',
    title: 'Reeza Hendricks',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63345055258445b807483a4f',
    matchId: '63344fdc258445b807480bf7',
    playerId: '49706',
    teamId: 19,
    firstName: 'Keshav Maharaj',
    lastName: '',
    middleName: '',
    shortName: 'Keshav Maharaj',
    title: 'Keshav Maharaj',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 5.75,
    strikeRate: 0,
    points: 66
  },
  {
    id: '63354d75258445b8077c8a2b',
    matchId: '63344fdc258445b807480bf7',
    playerId: '53000',
    teamId: 19,
    firstName: 'Andile Phehlukwayo',
    lastName: '',
    middleName: '',
    shortName: 'Andile Phehlukwayo',
    title: 'Andile Phehlukwayo',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63345055258445b807483a7f',
    matchId: '63344fdc258445b807480bf7',
    playerId: '53819',
    teamId: 25,
    firstName: 'Deepak Chahar',
    lastName: '',
    middleName: '',
    shortName: 'DL Chahar',
    title: 'Deepak Chahar',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 1,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 6,
    strikeRate: 0,
    points: 18
  },
  {
    id: '63345055258445b807483a51',
    matchId: '63344fdc258445b807480bf7',
    playerId: '57187',
    teamId: 19,
    firstName: 'Anrich Nortje',
    lastName: '',
    middleName: '',
    shortName: 'Anrich Nortje',
    title: 'Anrich Nortje',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 1,
    startingEleven: 1,
    economyRate: 13.67,
    strikeRate: 0,
    points: 4
  },
  {
    id: '63345055258445b807483a60',
    matchId: '63344fdc258445b807480bf7',
    playerId: '598',
    teamId: 25,
    firstName: 'Suryakumar Yadav',
    lastName: '',
    middleName: '',
    shortName: 'SA Yadav',
    title: 'Suryakumar Yadav',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 61,
    boundary: 5,
    six: 5,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 277.27,
    points: 94
  },
  {
    id: '63345055258445b807483a39',
    matchId: '63344fdc258445b807480bf7',
    playerId: '60288',
    teamId: 19,
    firstName: 'Tristan Stubbs',
    lastName: '',
    middleName: '',
    shortName: 'Tristan Stubbs',
    title: 'Tristan Stubbs',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 12
  },
  {
    id: '63354ded258445b8077c9d4f',
    matchId: '63344fdc258445b807480bf7',
    playerId: '60394',
    teamId: 19,
    firstName: 'Marco Jansen',
    lastName: '',
    middleName: '',
    shortName: 'M Jansen',
    title: 'Marco Jansen',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Fast',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63345055258445b807483a78',
    matchId: '63344fdc258445b807480bf7',
    playerId: '607',
    teamId: 25,
    firstName: 'Jasprit Bumrah',
    lastName: '',
    middleName: '',
    shortName: 'JJ Bumrah',
    title: 'Jasprit Bumrah',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63345055258445b807483a63',
    matchId: '63344fdc258445b807480bf7',
    playerId: '620',
    teamId: 25,
    firstName: 'Shreyas Iyer',
    lastName: '',
    middleName: '',
    shortName: 'S Iyer',
    title: 'Shreyas Iyer',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63345055258445b807483a73',
    matchId: '63344fdc258445b807480bf7',
    playerId: '634',
    teamId: 25,
    firstName: 'Axar Patel',
    lastName: '',
    middleName: '',
    shortName: 'Axar Patel',
    title: 'Axar Patel',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 13.25,
    strikeRate: 0,
    points: 31
  },
  {
    id: '63345055258445b807483a54',
    matchId: '63344fdc258445b807480bf7',
    playerId: '649',
    teamId: 25,
    firstName: 'Dinesh Karthik',
    lastName: '',
    middleName: '',
    shortName: 'Dinesh Karthik',
    title: 'Dinesh Karthik',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 17,
    boundary: 1,
    six: 2,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 242.86,
    points: 34
  },
  {
    id: '63345055258445b807483a7d',
    matchId: '63344fdc258445b807480bf7',
    playerId: '652',
    teamId: 25,
    firstName: 'Harshal Patel',
    lastName: '',
    middleName: '',
    shortName: 'HV Patel',
    title: 'Harshal Patel',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 11.25,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63345055258445b807483a7a',
    matchId: '63344fdc258445b807480bf7',
    playerId: '654',
    teamId: 25,
    firstName: 'Yuzvendra Chahal',
    lastName: '',
    middleName: '',
    shortName: 'Yuzvendra Chahal',
    title: 'Yuzvendra Chahal',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63345055258445b807483a66',
    matchId: '63344fdc258445b807480bf7',
    playerId: '661',
    teamId: 25,
    firstName: 'KL Rahul',
    lastName: '',
    middleName: '',
    shortName: 'KL Rahul',
    title: 'KL Rahul',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 57,
    boundary: 5,
    six: 4,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 1,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 203.57,
    points: 88
  },
  {
    id: '63345055258445b807483a44',
    matchId: '63344fdc258445b807480bf7',
    playerId: '90298',
    teamId: 19,
    firstName: 'Dwaine Pretorius',
    lastName: '',
    middleName: '',
    shortName: 'Dwaine Pretorius',
    title: 'Dwaine Pretorius',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63367795258445b807acd3f6',
    matchId: '63344fdc258445b807480bf7',
    playerId: '90381',
    teamId: 25,
    firstName: 'Mohammed Siraj',
    lastName: '',
    middleName: '',
    shortName: 'Mohammed Siraj',
    title: 'Mohammed Siraj',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63345055258445b807483a82',
    matchId: '63344fdc258445b807480bf7',
    playerId: '93497',
    teamId: 25,
    firstName: 'Arshdeep Singh',
    lastName: '',
    middleName: '',
    shortName: 'Arshdeep Singh',
    title: 'Arshdeep Singh',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 15.5,
    strikeRate: 0,
    points: 48
  },
  {
    id: '63345055258445b807483a77',
    matchId: '63344fdc258445b807480bf7',
    playerId: '94088',
    teamId: 25,
    firstName: 'Shahbaz Ahmed',
    lastName: '',
    middleName: '',
    shortName: 'Shahbaz Ahmed',
    title: 'Shahbaz Ahmed',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  }
];
export const slVsAfgT20PlayerList = [
  {
    id: '6307271c7e2d41535f39f815',
    matchId: '630727157e2d41535f39f628',
    playerId: '102210',
    teamId: 498,
    firstName: 'Noor Ahmad',
    lastName: '',
    middleName: '',
    shortName: 'Noor Ahmad',
    title: 'Noor Ahmad',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Wrist Spin',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f786',
    matchId: '630727157e2d41535f39f628',
    playerId: '1137',
    teamId: 21,
    firstName: 'Charith Asalanka',
    lastName: '',
    middleName: '',
    shortName: 'C Asalanka',
    title: 'Charith Asalanka',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 1,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 6,
    strikeRate: 0,
    points: 2
  },
  {
    id: '6307271c7e2d41535f39f794',
    matchId: '630727157e2d41535f39f628',
    playerId: '1140',
    teamId: 21,
    firstName: 'Wanindu Hasaranga',
    lastName: '',
    middleName: '',
    shortName: 'W Hasaranga',
    title: 'Wanindu Hasaranga',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 9.5,
    run: 2,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 6.33,
    strikeRate: 25,
    points: 41
  },
  {
    id: '6307271c7e2d41535f39f7a9',
    matchId: '630727157e2d41535f39f628',
    playerId: '1143',
    teamId: 21,
    firstName: 'Asitha Fernando',
    lastName: '',
    middleName: '',
    shortName: 'AM Fernando',
    title: 'Asitha Fernando',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f7e5',
    matchId: '630727157e2d41535f39f628',
    playerId: '1150',
    teamId: 498,
    firstName: 'Karim Janat',
    lastName: '',
    middleName: '',
    shortName: 'Karim Janat',
    title: 'Karim Janat',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 12
  },
  {
    id: '6307271c7e2d41535f39f7ef',
    matchId: '630727157e2d41535f39f628',
    playerId: '1157',
    teamId: 498,
    firstName: 'Rashid Khan',
    lastName: '',
    middleName: '',
    shortName: 'Rashid Khan',
    title: 'Rashid Khan',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 9.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 3,
    strikeRate: 0,
    points: 10
  },
  {
    id: '6307271c7e2d41535f39f80d',
    matchId: '630727157e2d41535f39f628',
    playerId: '1317',
    teamId: 498,
    firstName: 'Nijat Masood',
    lastName: '',
    middleName: '',
    shortName: 'Nijat Masood',
    title: 'Nijat Masood',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f7f6',
    matchId: '630727157e2d41535f39f628',
    playerId: '1404',
    teamId: 498,
    firstName: 'Naveen-ul-Haq',
    lastName: '',
    middleName: '',
    shortName: 'Naveen-ul-Haq',
    title: 'Naveen-ul-Haq',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 1,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 7.67,
    strikeRate: 0,
    points: 29
  },
  {
    id: '6307271c7e2d41535f39f798',
    matchId: '630727157e2d41535f39f628',
    playerId: '1734',
    teamId: 21,
    firstName: 'Dasun Shanaka',
    lastName: '',
    middleName: '',
    shortName: 'D Shanaka',
    title: 'Dasun Shanaka',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 1,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 0,
    points: 2
  },
  {
    id: '6307271c7e2d41535f39f7a2',
    matchId: '630727157e2d41535f39f628',
    playerId: '1765',
    teamId: 21,
    firstName: 'Jeffrey Vandersay',
    lastName: '',
    middleName: '',
    shortName: 'JF Vandersay',
    title: 'Jeffrey Vandersay',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f7cb',
    matchId: '630727157e2d41535f39f628',
    playerId: '311',
    teamId: 498,
    firstName: 'Afsar Zazai',
    lastName: '',
    middleName: '',
    shortName: 'Afsar Zazai',
    title: 'Afsar Zazai',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f7da',
    matchId: '630727157e2d41535f39f628',
    playerId: '317',
    teamId: 498,
    firstName: 'Samiullah Shenwari',
    lastName: '',
    middleName: '',
    shortName: 'S Shenwari',
    title: 'Samiullah Shenwari',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f7e3',
    matchId: '630727157e2d41535f39f628',
    playerId: '319',
    teamId: 498,
    firstName: 'Mohammad Nabi',
    lastName: '',
    middleName: '',
    shortName: 'Mohammad Nabi',
    title: 'Mohammad Nabi',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 1,
    runOutThrow: 0,
    runOutCatch: 1,
    startingEleven: 1,
    economyRate: 3.5,
    strikeRate: 0,
    points: 74
  },
  {
    id: '6307271c7e2d41535f39f7cf',
    matchId: '630727157e2d41535f39f628',
    playerId: '321',
    teamId: 498,
    firstName: 'Najibullah Zadran',
    lastName: '',
    middleName: '',
    shortName: 'Najibullah Zadran',
    title: 'Najibullah Zadran',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 9,
    run: 2,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 100,
    points: 14
  },
  {
    id: '6307271c7e2d41535f39f782',
    matchId: '630727157e2d41535f39f628',
    playerId: '426',
    teamId: 21,
    firstName: 'Dinesh Chandimal',
    lastName: '',
    middleName: '',
    shortName: 'D Chandimal',
    title: 'Dinesh Chandimal',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f79c',
    matchId: '630727157e2d41535f39f628',
    playerId: '43745',
    teamId: 21,
    firstName: 'Dhananjaya de Silva',
    lastName: '',
    middleName: '',
    shortName: 'D de Silva',
    title: 'Dhananjaya de Silva',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f79e',
    matchId: '630727157e2d41535f39f628',
    playerId: '43761',
    teamId: 21,
    firstName: 'Chamika Karunaratne',
    lastName: '',
    middleName: '',
    shortName: 'C Karunaratne',
    title: 'Chamika Karunaratne',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 31,
    boundary: 3,
    six: 1,
    thirtyRuns: 1,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 20,
    strikeRate: 81.58,
    points: 44
  },
  {
    id: '6307271c7e2d41535f39f7ad',
    matchId: '630727157e2d41535f39f628',
    playerId: '43820',
    teamId: 21,
    firstName: 'Nuwan Thushara',
    lastName: '',
    middleName: '',
    shortName: 'N Thushara',
    title: 'Nuwan Thushara',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f78f',
    matchId: '630727157e2d41535f39f628',
    playerId: '43908',
    teamId: 21,
    firstName: 'Ashen Bandara',
    lastName: '',
    middleName: '',
    shortName: 'KNA Bandara',
    title: 'Ashen Bandara',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f784',
    matchId: '630727157e2d41535f39f628',
    playerId: '43953',
    teamId: 21,
    firstName: 'Kusal Mendis',
    lastName: '',
    middleName: '',
    shortName: 'K Mendis',
    title: 'Kusal Mendis',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 2,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 50,
    points: 6
  },
  {
    id: '6307271c7e2d41535f39f7b0',
    matchId: '630727157e2d41535f39f628',
    playerId: '43959',
    teamId: 21,
    firstName: 'Pramod Madushan',
    lastName: '',
    middleName: '',
    shortName: 'PM Liyanagamage',
    title: 'Pramod Madushan',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f78c',
    matchId: '630727157e2d41535f39f628',
    playerId: '43961',
    teamId: 21,
    firstName: 'Danushka Gunathilaka',
    lastName: '',
    middleName: '',
    shortName: 'D Gunathilaka',
    title: 'Danushka Gunathilaka',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 17,
    boundary: 3,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 100,
    points: 24
  },
  {
    id: '6307271c7e2d41535f39f7d7',
    matchId: '630727157e2d41535f39f628',
    playerId: '440',
    teamId: 498,
    firstName: 'Usman Ghani',
    lastName: '',
    middleName: '',
    shortName: 'Usman Ghani',
    title: 'Usman Ghani',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f7d8',
    matchId: '630727157e2d41535f39f628',
    playerId: '44991',
    teamId: 498,
    firstName: 'Hashmatullah Shahidi',
    lastName: '',
    middleName: '',
    shortName: 'Hashmatullah Shahidi',
    title: 'Hashmatullah Shahidi',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f7ec',
    matchId: '630727157e2d41535f39f628',
    playerId: '45009',
    teamId: 498,
    firstName: 'Sharafuddin Ashraf',
    lastName: '',
    middleName: '',
    shortName: 'Sharafuddin Ashraf',
    title: 'Sharafuddin Ashraf',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f811',
    matchId: '630727157e2d41535f39f628',
    playerId: '45056',
    teamId: 498,
    firstName: 'Qais Ahmad',
    lastName: '',
    middleName: '',
    shortName: 'Qais Ahmad',
    title: 'Qais Ahmad',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f7df',
    matchId: '630727157e2d41535f39f628',
    playerId: '45172',
    teamId: 498,
    firstName: 'Ibrahim Zadran',
    lastName: '',
    middleName: '',
    shortName: 'Ibrahim Zadran',
    title: 'Ibrahim Zadran',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8,
    run: 15,
    boundary: 2,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 115.38,
    points: 21
  },
  {
    id: '6307271c7e2d41535f39f7d3',
    matchId: '630727157e2d41535f39f628',
    playerId: '47389',
    teamId: 498,
    firstName: 'Hazratullah Zazai',
    lastName: '',
    middleName: '',
    shortName: 'Hazratullah Zazai',
    title: 'Hazratullah Zazai',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 9,
    run: 37,
    boundary: 5,
    six: 1,
    thirtyRuns: 1,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 132.14,
    points: 54
  },
  {
    id: '6307271c7e2d41535f39f789',
    matchId: '630727157e2d41535f39f628',
    playerId: '52307',
    teamId: 21,
    firstName: 'Bhanuka Rajapaksa',
    lastName: '',
    middleName: '',
    shortName: 'B Rajapaksa',
    title: 'Bhanuka Rajapaksa',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 9,
    run: 38,
    boundary: 5,
    six: 1,
    thirtyRuns: 1,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 131.03,
    points: 55
  },
  {
    id: '6307271c7e2d41535f39f7fa',
    matchId: '630727157e2d41535f39f628',
    playerId: '59085',
    teamId: 498,
    firstName: 'Fareed Malik',
    lastName: '',
    middleName: '',
    shortName: 'Farid Malik',
    title: 'Fareed Malik',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f809',
    matchId: '630727157e2d41535f39f628',
    playerId: '62778',
    teamId: 498,
    firstName: 'Fazalhaq Farooqi',
    lastName: '',
    middleName: '',
    shortName: 'Fazalhaq Farooqi',
    title: 'Fazalhaq Farooqi',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 3,
    twoWicketHaul: 0,
    threeWicketHaul: 1,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 1,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 1,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 3,
    strikeRate: 0,
    points: 131
  },
  {
    id: '6307271c7e2d41535f39f78a',
    matchId: '630727157e2d41535f39f628',
    playerId: '84107',
    teamId: 21,
    firstName: 'Pathum Nissanka',
    lastName: '',
    middleName: '',
    shortName: 'Pathum Nissanka',
    title: 'Pathum Nissanka',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 9,
    run: 3,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 42.86,
    points: 7
  },
  {
    id: '6307271c7e2d41535f39f7b3',
    matchId: '630727157e2d41535f39f628',
    playerId: '90785',
    teamId: 21,
    firstName: 'Praveen Jayawickrama',
    lastName: '',
    middleName: '',
    shortName: 'P Jayawickrama',
    title: 'Praveen Jayawickrama',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f791',
    matchId: '630727157e2d41535f39f628',
    playerId: '93179',
    teamId: 21,
    firstName: 'Nuwanidu Fernando',
    lastName: '',
    middleName: '',
    shortName: 'MNK Fernando',
    title: 'Nuwanidu Fernando',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '6307271c7e2d41535f39f7f3',
    matchId: '630727157e2d41535f39f628',
    playerId: '93418',
    teamId: 498,
    firstName: 'Mujeeb Ur Rahman',
    lastName: '',
    middleName: '',
    shortName: 'Mujeeb Ur Rahman',
    title: 'Mujeeb Ur Rahman',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 6,
    strikeRate: 0,
    points: 56
  },
  {
    id: '6307271c7e2d41535f39f7e9',
    matchId: '630727157e2d41535f39f628',
    playerId: '93481',
    teamId: 498,
    firstName: 'Azmatullah Omarzai',
    lastName: '',
    middleName: '',
    shortName: 'Azmatullah Omarzai',
    title: 'Azmatullah Omarzai',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 1,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 20,
    strikeRate: 0,
    points: 10
  },
  {
    id: '6307271c7e2d41535f39f7c2',
    matchId: '630727157e2d41535f39f628',
    playerId: '93570',
    teamId: 498,
    firstName: 'Rahmanullah Gurbaz',
    lastName: '',
    middleName: '',
    shortName: 'Rahmanullah Gurbaz',
    title: 'Rahmanullah Gurbaz',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Afghanistan',
    thumbUrl: '',
    rating: 9,
    run: 40,
    boundary: 3,
    six: 4,
    thirtyRuns: 1,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 2,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 1,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 222.22,
    points: 87
  },
  {
    id: '6307271c7e2d41535f39f7a6',
    matchId: '630727157e2d41535f39f628',
    playerId: '94457',
    teamId: 21,
    firstName: 'Maheesh Theekshana',
    lastName: '',
    middleName: '',
    shortName: 'M Theekshana',
    title: 'Maheesh Theekshana',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 1,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 8.75,
    strikeRate: 0,
    points: 16
  },
  {
    id: '6307271c7e2d41535f39f7b7',
    matchId: '630727157e2d41535f39f628',
    playerId: '95301',
    teamId: 21,
    firstName: 'Dilshan Madushanka',
    lastName: '',
    middleName: '',
    shortName: 'D Madushanka',
    title: 'Dilshan Madushanka',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8,
    run: 1,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 10,
    strikeRate: 0,
    points: 5
  },
  {
    id: '6307271c7e2d41535f39f7bb',
    matchId: '630727157e2d41535f39f628',
    playerId: '95635',
    teamId: 21,
    firstName: 'Matheesha Pathirana',
    lastName: '',
    middleName: '',
    shortName: 'Matheesha Pathirana',
    title: 'Matheesha Pathirana',
    playingEleven: true,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Sri Lanka',
    thumbUrl: '',
    rating: 8,
    run: 5,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 16,
    strikeRate: 0,
    points: 9
  }
];
export const wiWVsIndWT20PlayerList = [
  {
    id: '63cc01c296851a4d7f92ea51',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '112790',
    teamId: 9536,
    firstName: 'Amanjot Kaur',
    lastName: '',
    middleName: '',
    shortName: 'Amanjot Kaur',
    title: 'Amanjot Kaur',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 70
  },
  {
    id: '63cc01c296851a4d7f92ea37',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '44703',
    teamId: 9536,
    firstName: 'Smriti Mandhana',
    lastName: '',
    middleName: '',
    shortName: 'Smriti Mandhana',
    title: 'Smriti Mandhana',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 112
  },
  {
    id: '63cc01c296851a4d7f92ea38',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '44708',
    teamId: 9536,
    firstName: 'Harmanpreet Kaur',
    lastName: '',
    middleName: '',
    shortName: 'Harmanpreet Kaur',
    title: 'Harmanpreet Kaur',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 84
  },
  {
    id: '63cc01c296851a4d7f92ea39',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '44714',
    teamId: 9536,
    firstName: 'Shikha Pandey',
    lastName: '',
    middleName: '',
    shortName: 'S Pandey',
    title: 'Shikha Pandey',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 10
  },
  {
    id: '63cc01c296851a4d7f92ea3b',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '44718',
    teamId: 9536,
    firstName: 'Sushma Verma',
    lastName: '',
    middleName: '',
    shortName: 'S Verma',
    title: 'Sushma Verma',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cc01c296851a4d7f92ea3d',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '44728',
    teamId: 9536,
    firstName: 'Rajeshwari Gayakwad',
    lastName: '',
    middleName: '',
    shortName: 'Rajeshwari Gayakwad',
    title: 'Rajeshwari Gayakwad',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 84
  },
  {
    id: '63cc01c296851a4d7f92ea3e',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '44740',
    teamId: 9536,
    firstName: 'Deepti Sharma',
    lastName: '',
    middleName: '',
    shortName: 'Deepti Sharma',
    title: 'Deepti Sharma',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 203
  },
  {
    id: '63cc01c296851a4d7f92ea40',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '44801',
    teamId: 9536,
    firstName: 'Sneh Rana',
    lastName: '',
    middleName: '',
    shortName: 'Sneh Rana',
    title: 'Sneh Rana',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 53
  },
  {
    id: '63cc01c296851a4d7f92ea41',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '47751',
    teamId: 9536,
    firstName: 'Devika Vaidya',
    lastName: '',
    middleName: '',
    shortName: 'DP Vaidya',
    title: 'Devika Vaidya',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 69
  },
  {
    id: '63cc01c296851a4d7f92ea42',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '47819',
    teamId: 9536,
    firstName: 'Sabbhineni Meghana',
    lastName: '',
    middleName: '',
    shortName: 'Sabbhineni Meghana',
    title: 'Sabbhineni Meghana',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cc01c296851a4d7f92ea43',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '47825',
    teamId: 9536,
    firstName: 'Anjali Sarwani',
    lastName: '',
    middleName: '',
    shortName: 'K Anjali Sarwani',
    title: 'Anjali Sarwani',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 4
  },
  {
    id: '63cc01c296851a4d7f92ea45',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '47874',
    teamId: 9536,
    firstName: 'Pooja Vastrakar',
    lastName: '',
    middleName: '',
    shortName: 'Pooja Vastrakar',
    title: 'Pooja Vastrakar',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cc01c296851a4d7f92ea46',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '47892',
    teamId: 9536,
    firstName: 'Harleen Deol',
    lastName: '',
    middleName: '',
    shortName: 'Harleen Deol',
    title: 'Harleen Deol',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 31
  },
  {
    id: '63cc01c296851a4d7f92ea47',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '47899',
    teamId: 9536,
    firstName: 'Renuka Singh',
    lastName: '',
    middleName: '',
    shortName: 'Renuka Singh',
    title: 'Renuka Singh',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cc01c296851a4d7f92ea48',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '47972',
    teamId: 9536,
    firstName: 'Radha Yadav',
    lastName: '',
    middleName: '',
    shortName: 'Radha Yadav',
    title: 'Radha Yadav',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 84
  },
  {
    id: '63cc01c296851a4d7f92ea4a',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '47979',
    teamId: 9536,
    firstName: 'Yastika Bhatia',
    lastName: '',
    middleName: '',
    shortName: 'Yastika Bhatia',
    title: 'Yastika Bhatia',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 103
  },
  {
    id: '63cc01c296851a4d7f92ea4c',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '52074',
    teamId: 9536,
    firstName: 'Meghna Singh',
    lastName: '',
    middleName: '',
    shortName: 'Meghna Singh',
    title: 'Meghna Singh',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cc01c296851a4d7f92ea4e',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '52086',
    teamId: 9536,
    firstName: 'Jemimah Rodrigues',
    lastName: '',
    middleName: '',
    shortName: 'Jemimah Rodrigues',
    title: 'Jemimah Rodrigues',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 6
  },
  {
    id: '63cc01c296851a4d7f92ea6d',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '103376',
    teamId: 10272,
    firstName: 'Kaysia Schultz',
    lastName: '',
    middleName: '',
    shortName: 'Kaysia Schultz',
    title: 'Kaysia Schultz',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 14
  },
  {
    id: '63cc01c296851a4d7f92ea52',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '43021',
    teamId: 10272,
    firstName: 'Hayley Matthews',
    lastName: '',
    middleName: '',
    shortName: 'Hayley Matthews',
    title: 'Hayley Matthews',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 153
  },
  {
    id: '63cc01c296851a4d7f92ea53',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '43023',
    teamId: 10272,
    firstName: 'Aaliyah Alleyne',
    lastName: '',
    middleName: '',
    shortName: 'Aaliyah Alleyne',
    title: 'Aaliyah Alleyne',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cc01c296851a4d7f92ea55',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '43024',
    teamId: 10272,
    firstName: 'Shakera Selman',
    lastName: '',
    middleName: '',
    shortName: 'Shakera Selman',
    title: 'Shakera Selman',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 13
  },
  {
    id: '63cc01c296851a4d7f92ea57',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '43033',
    teamId: 10272,
    firstName: 'Stafanie Taylor',
    lastName: '',
    middleName: '',
    shortName: 'Stafanie Taylor',
    title: 'Stafanie Taylor',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cc01c296851a4d7f92ea59',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '43035',
    teamId: 10272,
    firstName: 'Chedean Nation',
    lastName: '',
    middleName: '',
    shortName: 'Chedean Nation',
    title: 'Chedean Nation',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 14
  },
  {
    id: '63cc01c296851a4d7f92ea5a',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '43037',
    teamId: 10272,
    firstName: 'Chinelle Henry',
    lastName: '',
    middleName: '',
    shortName: 'Chinelle Henry',
    title: 'Chinelle Henry',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cc01c296851a4d7f92ea5b',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '44323',
    teamId: 10272,
    firstName: 'Britney Cooper',
    lastName: '',
    middleName: '',
    shortName: 'B Cooper',
    title: 'Britney Cooper',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 47
  },
  {
    id: '63cc01c296851a4d7f92ea5e',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '44326',
    teamId: 10272,
    firstName: 'Afy Fletcher',
    lastName: '',
    middleName: '',
    shortName: 'Afy Fletcher',
    title: 'Afy Fletcher',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 36
  },
  {
    id: '63cc01c296851a4d7f92ea5f',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '44339',
    teamId: 10272,
    firstName: 'Shamilia Connell',
    lastName: '',
    middleName: '',
    shortName: 'SS Connell',
    title: 'Shamilia Connell',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 97
  },
  {
    id: '63cc01c296851a4d7f92ea60',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '44348',
    teamId: 10272,
    firstName: 'Shemaine Campbelle',
    lastName: '',
    middleName: '',
    shortName: 'Shemaine Campbelle',
    title: 'Shemaine Campbelle',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 82
  },
  {
    id: '63cc01c296851a4d7f92ea61',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '58461',
    teamId: 10272,
    firstName: 'Rashada Williams',
    lastName: '',
    middleName: '',
    shortName: 'RS Williams',
    title: 'Rashada Williams',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 39
  },
  {
    id: '63cc01c296851a4d7f92ea62',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '58486',
    teamId: 10272,
    firstName: 'Karishma Ramharack',
    lastName: '',
    middleName: '',
    shortName: 'K Ramharack',
    title: 'Karishma Ramharack',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 43
  },
  {
    id: '63cc01c296851a4d7f92ea65',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '62844',
    teamId: 10272,
    firstName: 'Shanika Bruce',
    lastName: '',
    middleName: '',
    shortName: 'SJ Bruce',
    title: 'Shanika Bruce',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 45
  },
  {
    id: '63cc01c296851a4d7f92ea69',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '83128',
    teamId: 10272,
    firstName: 'Sheneta Grimmond',
    lastName: '',
    middleName: '',
    shortName: 'Sheneta Grimmond',
    title: 'Sheneta Grimmond',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 10
  },
  {
    id: '63cc01c296851a4d7f92ea6b',
    matchId: '63cc017596851a4d7f92dbc2',
    playerId: '95933',
    teamId: 10272,
    firstName: 'Shabika Gajnabi',
    lastName: '',
    middleName: '',
    shortName: 'Shabika Gajnabi',
    title: 'Shabika Gajnabi',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'West Indies',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    totalPointsOfPreviousMatches: 83
  }
];
export const indVsZimPlayerList = [
  {
    id: '62fdf27a1f7aacc4e35331de',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '107434',
    teamId: 493,
    firstName: 'Clive Madande',
    lastName: '',
    middleName: '',
    shortName: 'Clive Madande',
    title: 'Clive Madande',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62fdf27a1f7aacc4e3533257',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '107438',
    teamId: 493,
    firstName: 'Tanaka Chivanga',
    lastName: '',
    middleName: '',
    shortName: 'Tanaka Chivanga',
    title: 'Tanaka Chivanga',
    playingEleven: true,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8,
    run: 4,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 5.43,
    strikeRate: 0,
    points: 34
  },
  {
    id: '62fdf27a1f7aacc4e353320e',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '107439',
    teamId: 493,
    firstName: 'Takudzwanashe Kaitano',
    lastName: '',
    middleName: '',
    shortName: 'Takudzwanashe Kaitano',
    title: 'Takudzwanashe Kaitano',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8,
    run: 7,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 21.88,
    points: 5
  },
  {
    id: '62fdf27a1f7aacc4e3533180',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '1097',
    teamId: 25,
    firstName: 'Ishan Kishan',
    lastName: '',
    middleName: '',
    shortName: 'Ishan Kishan',
    title: 'Ishan Kishan',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 6,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 46.15,
    points: 18
  },
  {
    id: '62fdf27a1f7aacc4e35331d0',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '1104',
    teamId: 25,
    firstName: 'Avesh Khan',
    lastName: '',
    middleName: '',
    shortName: 'Avesh Khan',
    title: 'Avesh Khan',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62fdf27a1f7aacc4e3533185',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '117',
    teamId: 25,
    firstName: 'Shikhar Dhawan',
    lastName: '',
    middleName: '',
    shortName: 'Shikhar Dhawan',
    title: 'Shikhar Dhawan',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 10.5,
    run: 33,
    boundary: 4,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 157.14,
    points: 55
  },
  {
    id: '62fdf27a1f7aacc4e353322e',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '1222',
    teamId: 493,
    firstName: 'Richard Ngarava',
    lastName: '',
    middleName: '',
    shortName: 'R Ngarava',
    title: 'Richard Ngarava',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62fdf27a1f7aacc4e3533220',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '1224',
    teamId: 493,
    firstName: 'Wesley Madhevere',
    lastName: '',
    middleName: '',
    shortName: 'W Madhevere',
    title: 'Wesley Madhevere',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8.5,
    run: 2,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 7,
    strikeRate: 16.67,
    points: 6
  },
  {
    id: '62fdf27a1f7aacc4e3533205',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '1310',
    teamId: 493,
    firstName: 'Milton Shumba',
    lastName: '',
    middleName: '',
    shortName: 'M Shumba',
    title: 'Milton Shumba',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62fdf27a1f7aacc4e3533233',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '1810',
    teamId: 493,
    firstName: 'Donald Tiripano',
    lastName: '',
    middleName: '',
    shortName: 'DT Tiripano',
    title: 'Donald Tiripano',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62fdf27a1f7aacc4e3533218',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '183',
    teamId: 493,
    firstName: 'Sikandar Raza',
    lastName: '',
    middleName: '',
    shortName: 'Sikandar Raza',
    title: 'Sikandar Raza',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 9.5,
    run: 16,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 4,
    strikeRate: 51.61,
    points: 53
  },
  {
    id: '62fdf27a1f7aacc4e353321c',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '189',
    teamId: 493,
    firstName: 'Sean Williams',
    lastName: '',
    middleName: '',
    shortName: 'SC Williams',
    title: 'Sean Williams',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 9,
    run: 42,
    boundary: 3,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 13,
    strikeRate: 100,
    points: 53
  },
  {
    id: '62fdf27a1f7aacc4e35331d7',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '384',
    teamId: 493,
    firstName: 'Regis Chakabva',
    lastName: '',
    middleName: '',
    shortName: 'RW Chakabva',
    title: 'Regis Chakabva',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 9,
    run: 2,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 40,
    points: 6
  },
  {
    id: '62fdf27a1f7aacc4e353323a',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '44108',
    teamId: 493,
    firstName: 'Luke Jongwe',
    lastName: '',
    middleName: '',
    shortName: 'LM Jongwe',
    title: 'Luke Jongwe',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8.5,
    run: 6,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 2,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 8.25,
    strikeRate: 0,
    points: 69
  },
  {
    id: '62fdf27a1f7aacc4e3533242',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '44163',
    teamId: 493,
    firstName: 'Victor Nyauchi',
    lastName: '',
    middleName: '',
    shortName: 'VM Nyauchi',
    title: 'Victor Nyauchi',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 8,
    strikeRate: 0,
    points: 37
  },
  {
    id: '62fdf27a1f7aacc4e35331ec',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '45657',
    teamId: 493,
    firstName: 'Tadiwanashe Marumani',
    lastName: '',
    middleName: '',
    shortName: 'T Marumani',
    title: 'Tadiwanashe Marumani',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62fdf27a1f7aacc4e35331f6',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '50833',
    teamId: 493,
    firstName: 'Ryan Burl',
    lastName: '',
    middleName: '',
    shortName: 'RP Burl',
    title: 'Ryan Burl',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8.5,
    run: 39,
    boundary: 3,
    six: 1,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 82.98,
    points: 48
  },
  {
    id: '62fdf27a1f7aacc4e35331fd',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '53650',
    teamId: 493,
    firstName: 'Innocent Kaia',
    lastName: '',
    middleName: '',
    shortName: 'I Kaia',
    title: 'Innocent Kaia',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8.5,
    run: 16,
    boundary: 2,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 9,
    strikeRate: 59.26,
    points: 30
  },
  {
    id: '62fdf27a1f7aacc4e35331ba',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '53819',
    teamId: 25,
    firstName: 'Deepak Chahar',
    lastName: '',
    middleName: '',
    shortName: 'DL Chahar',
    title: 'Deepak Chahar',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62fdf27a1f7aacc4e3533191',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '54129',
    teamId: 25,
    firstName: 'Rahul Tripathi',
    lastName: '',
    middleName: '',
    shortName: 'RA Tripathi',
    title: 'Rahul Tripathi',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62fdf27a1f7aacc4e3533248',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '61360',
    teamId: 493,
    firstName: 'Brad Evans',
    lastName: '',
    middleName: '',
    shortName: 'B Evans',
    title: 'Brad Evans',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8,
    run: 9,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 5.25,
    strikeRate: 0,
    points: 22
  },
  {
    id: '62fdf27a1f7aacc4e35331a0',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '634',
    teamId: 25,
    firstName: 'Axar Patel',
    lastName: '',
    middleName: '',
    shortName: 'Axar Patel',
    title: 'Axar Patel',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 6,
    boundary: 1,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 1,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 2.86,
    strikeRate: 85.71,
    points: 52
  },
  {
    id: '62fdf27a1f7aacc4e353317f',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '638',
    teamId: 25,
    firstName: 'Sanju Samson',
    lastName: '',
    middleName: '',
    shortName: 'SV Samson',
    title: 'Sanju Samson',
    playingEleven: true,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 43,
    boundary: 3,
    six: 4,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 3,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 1,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 110.26,
    points: 94
  },
  {
    id: '62fdf27a1f7aacc4e35331a4',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '641',
    teamId: 25,
    firstName: 'Deepak Hooda',
    lastName: '',
    middleName: '',
    shortName: 'Deepak Hooda',
    title: 'Deepak Hooda',
    playingEleven: true,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 25,
    boundary: 3,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 3,
    strikeRate: 69.44,
    points: 57
  },
  {
    id: '62fdf27a1f7aacc4e3533189',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '661',
    teamId: 25,
    firstName: 'KL Rahul',
    lastName: '',
    middleName: '',
    shortName: 'KL Rahul',
    title: 'KL Rahul',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9.5,
    run: 1,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 1,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 20,
    points: 5
  },
  {
    id: '62fdf27a1f7aacc4e35331b2',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '775',
    teamId: 25,
    firstName: 'Kuldeep Yadav',
    lastName: '',
    middleName: '',
    shortName: 'KL Yadav',
    title: 'Kuldeep Yadav',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Wrist Spin',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 1,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 6.13,
    strikeRate: 0,
    points: 35
  },
  {
    id: '62fdf27a1f7aacc4e35331bf',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '810',
    teamId: 25,
    firstName: 'Shardul Thakur',
    lastName: '',
    middleName: '',
    shortName: 'Shardul Thakur',
    title: 'Shardul Thakur',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 3,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 5.43,
    strikeRate: 0,
    points: 87
  },
  {
    id: '62fdf27a1f7aacc4e35331c7',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '90233',
    teamId: 25,
    firstName: 'Prasidh Krishna',
    lastName: '',
    middleName: '',
    shortName: 'Prasidh Krishna',
    title: 'Prasidh Krishna',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 1,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 1,
    startingEleven: 1,
    economyRate: 4.54,
    strikeRate: 0,
    points: 39
  },
  {
    id: '62fdf27a1f7aacc4e3533198',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '90363',
    teamId: 25,
    firstName: 'Ruturaj Gaikwad',
    lastName: '',
    middleName: '',
    shortName: 'RD Gaikwad',
    title: 'Ruturaj Gaikwad',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62fdf27a1f7aacc4e35331cb',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '90381',
    teamId: 25,
    firstName: 'Mohammed Siraj',
    lastName: '',
    middleName: '',
    shortName: 'Mohammed Siraj',
    title: 'Mohammed Siraj',
    playingEleven: true,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 1,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 2,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 1,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 2,
    strikeRate: 0,
    points: 49
  },
  {
    id: '62fdf27a1f7aacc4e353318d',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '90739',
    teamId: 25,
    firstName: 'Shubman Gill',
    lastName: '',
    middleName: '',
    shortName: 'Shubman Gill',
    title: 'Shubman Gill',
    playingEleven: true,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 33,
    boundary: 6,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 1,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 1,
    economyRate: 0,
    strikeRate: 97.06,
    points: 51
  },
  {
    id: '62fdf27a1f7aacc4e35331ac',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '94088',
    teamId: 25,
    firstName: 'Shahbaz Ahmed',
    lastName: '',
    middleName: '',
    shortName: 'Shahbaz Ahmed',
    title: 'Shahbaz Ahmed',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62fdf27a1f7aacc4e3533225',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '94868',
    teamId: 493,
    firstName: 'Tony Munyonga',
    lastName: '',
    middleName: '',
    shortName: 'T Munyonga',
    title: 'Tony Munyonga',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '62fdf27a1f7aacc4e353324b',
    matchId: '62fdf2711f7aacc4e352a767',
    playerId: '97052',
    teamId: 493,
    firstName: 'John Masara',
    lastName: '',
    middleName: '',
    shortName: 'John Masara',
    title: 'John Masara',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Zimbabwe',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  }
];
export const engWVsAusWU19PlayerList = [
  {
    id: '63d1675696851a4d7f805b97',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '102558',
    teamId: 127123,
    firstName: 'Niamh Holland',
    lastName: '',
    middleName: '',
    shortName: 'Niamh Holland',
    title: 'Niamh Holland',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b98',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '102763',
    teamId: 127123,
    firstName: 'Grace Scrivens',
    lastName: '',
    middleName: '',
    shortName: 'Grace Scrivens',
    title: 'Grace Scrivens',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b9a',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '102941',
    teamId: 127123,
    firstName: 'Liberty Heap',
    lastName: '',
    middleName: '',
    shortName: 'Liberty Heap',
    title: 'Liberty Heap',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b9c',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '102945',
    teamId: 127123,
    firstName: 'Hannah Baker',
    lastName: '',
    middleName: '',
    shortName: 'Hannah Baker',
    title: 'Hannah Baker',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b7f',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '103927',
    teamId: 127109,
    firstName: 'Ella Hayward',
    lastName: '',
    middleName: '',
    shortName: 'Ella Hayward',
    title: 'Ella Hayward',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b80',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '103928',
    teamId: 127109,
    firstName: 'Amy Smith',
    lastName: '',
    middleName: '',
    shortName: 'Amy Smith',
    title: 'Amy Smith',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b9e',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '107880',
    teamId: 127123,
    firstName: 'Alexa Stonehouse',
    lastName: '',
    middleName: '',
    shortName: 'Alexa Stonehouse',
    title: 'Alexa Stonehouse',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b9f',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '107883',
    teamId: 127123,
    firstName: 'Mary Taylor',
    lastName: '',
    middleName: '',
    shortName: 'Mary Taylor',
    title: 'Mary Taylor',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805ba0',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '110317',
    teamId: 127123,
    firstName: 'Josie Groves',
    lastName: '',
    middleName: '',
    shortName: 'Josie Groves',
    title: 'Josie Groves',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805ba1',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '110318',
    teamId: 127123,
    firstName: 'Davina Perrin',
    lastName: '',
    middleName: '',
    shortName: 'Davina Perrin',
    title: 'Davina Perrin',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805ba2',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '110326',
    teamId: 127123,
    firstName: 'Seren Smale',
    lastName: '',
    middleName: '',
    shortName: 'Seren Smale',
    title: 'Seren Smale',
    playingEleven: false,
    role: 'wk',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805ba4',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '110338',
    teamId: 127123,
    firstName: 'Ryana Macdonald-Gay',
    lastName: '',
    middleName: '',
    shortName: 'Ryana Macdonald-Gay',
    title: 'Ryana Macdonald-Gay',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b81',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '110957',
    teamId: 127109,
    firstName: 'Rhys McKenna',
    lastName: '',
    middleName: '',
    shortName: 'Rhys McKenna',
    title: 'Rhys McKenna',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b82',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '110958',
    teamId: 127109,
    firstName: 'Jade Allen',
    lastName: '',
    middleName: '',
    shortName: 'Jade Allen',
    title: 'Jade Allen',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b83',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '110959',
    teamId: 127109,
    firstName: 'Claire Moore',
    lastName: '',
    middleName: '',
    shortName: 'Claire Moore',
    title: 'Claire Moore',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b84',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '111170',
    teamId: 127109,
    firstName: 'Ella Wilson',
    lastName: '',
    middleName: '',
    shortName: 'Ella Wilson',
    title: 'Ella Wilson',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b85',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '114150',
    teamId: 127109,
    firstName: 'Charis Bekker',
    lastName: '',
    middleName: '',
    shortName: 'Charis Bekker',
    title: 'Charis Bekker',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805ba5',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '116256',
    teamId: 127123,
    firstName: 'Sophia Smale',
    lastName: '',
    middleName: '',
    shortName: 'Sophia Smale',
    title: 'Sophia Smale',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805ba6',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '116259',
    teamId: 127123,
    firstName: 'Emma Marlow',
    lastName: '',
    middleName: '',
    shortName: 'Emma Marlow',
    title: 'Emma Marlow',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805ba7',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '117710',
    teamId: 127123,
    firstName: 'Bethan Miles ',
    lastName: '',
    middleName: '',
    shortName: 'Bethan Miles',
    title: 'Bethan Miles ',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805ba9',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '119591',
    teamId: 127123,
    firstName: 'Lizzie Scott',
    lastName: '',
    middleName: '',
    shortName: 'Lizzie Scott',
    title: 'Lizzie Scott',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805bab',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '119593',
    teamId: 127123,
    firstName: 'Jemima Spence',
    lastName: '',
    middleName: '',
    shortName: 'Jemima Spence',
    title: 'Jemima Spence',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b87',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '119922',
    teamId: 127109,
    firstName: 'Paris Hall',
    lastName: '',
    middleName: '',
    shortName: 'P Hall',
    title: 'Paris Hall',
    playingEleven: false,
    role: 'wk',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b88',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '119923',
    teamId: 127109,
    firstName: 'Olivia Henry',
    lastName: '',
    middleName: '',
    shortName: 'Olivia Henry',
    title: 'Olivia Henry',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b89',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '121142',
    teamId: 127109,
    firstName: 'Paris Bowdler',
    lastName: '',
    middleName: '',
    shortName: 'Paris Bowdler',
    title: 'Paris Bowdler',
    playingEleven: false,
    role: 'wk',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805bac',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '122219',
    teamId: 127123,
    firstName: 'Ellie Anderson',
    lastName: '',
    middleName: '',
    shortName: 'Ellie Anderson',
    title: 'Ellie Anderson',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Rwanda',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805bad',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '122220',
    teamId: 127123,
    firstName: 'Charis Pavely',
    lastName: '',
    middleName: '',
    shortName: 'Charis Pavely',
    title: 'Charis Pavely',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Rwanda',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805bae',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '122221',
    teamId: 127123,
    firstName: 'Maddie Ward',
    lastName: '',
    middleName: '',
    shortName: 'Maddie Ward',
    title: 'Maddie Ward',
    playingEleven: false,
    role: 'wk',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Rwanda',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b8a',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '122424',
    teamId: 127109,
    firstName: 'Chloe Ainsworth',
    lastName: '',
    middleName: '',
    shortName: 'Chloe Ainsworth',
    title: 'Chloe Ainsworth',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b8b',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '123023',
    teamId: 127109,
    firstName: 'Kate Pelle',
    lastName: '',
    middleName: '',
    shortName: 'Kate Pelle',
    title: 'Kate Pelle',
    playingEleven: false,
    role: 'wk',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b8c',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '123046',
    teamId: 127109,
    firstName: 'Sianna Ginger',
    lastName: '',
    middleName: '',
    shortName: 'Sianna Ginger',
    title: 'Sianna Ginger',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b8d',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '123047',
    teamId: 127109,
    firstName: 'Lucy Hamilton',
    lastName: '',
    middleName: '',
    shortName: 'Lucy Hamilton',
    title: 'Lucy Hamilton',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Medium',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b8e',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '123048',
    teamId: 127109,
    firstName: 'Eleanor Larosa',
    lastName: '',
    middleName: '',
    shortName: 'Eleanor Larosa',
    title: 'Eleanor Larosa',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b8f',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '123049',
    teamId: 127109,
    firstName: 'Samira Dimeglio',
    lastName: '',
    middleName: '',
    shortName: 'Samira Dimeglio',
    title: 'Samira Dimeglio',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b91',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '123050',
    teamId: 127109,
    firstName: 'Milly Illingworth',
    lastName: '',
    middleName: '',
    shortName: 'Milly Illingworth',
    title: 'Milly Illingworth',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b94',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '123051',
    teamId: 127109,
    firstName: 'Sara Kennedy',
    lastName: '',
    middleName: '',
    shortName: 'Sara Kennedy',
    title: 'Sara Kennedy',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b95',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '123052',
    teamId: 127109,
    firstName: 'Maggie Clark',
    lastName: '',
    middleName: '',
    shortName: 'Maggie Clark',
    title: 'Maggie Clark',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805b96',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '123053',
    teamId: 127109,
    firstName: 'Ananaya Sharma',
    lastName: '',
    middleName: '',
    shortName: 'Ananaya Sharma',
    title: 'Ananaya Sharma',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'Australia',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805baf',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '123128',
    teamId: 127123,
    firstName: 'Emily Churms',
    lastName: '',
    middleName: '',
    shortName: 'Emily Churms',
    title: 'Emily Churms',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  },
  {
    id: '63d1675696851a4d7f805bb0',
    matchId: '63d166dc96851a4d7f804920',
    playerId: '123129',
    teamId: 127123,
    firstName: 'Charlotte Lambert',
    lastName: '',
    middleName: '',
    shortName: 'Charlotte Lambert',
    title: 'Charlotte Lambert',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'England',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0
  }
];
export const saWVsIndWPlayersList = [
  {
    id: '63cbff6996851a4d7f9285cf',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '112790',
    teamId: 9536,
    firstName: 'Amanjot Kaur',
    lastName: '',
    middleName: '',
    shortName: 'Amanjot Kaur',
    title: 'Amanjot Kaur',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 70
  },
  {
    id: '63cbff6996851a4d7f9285a9',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44703',
    teamId: 9536,
    firstName: 'Smriti Mandhana',
    lastName: '',
    middleName: '',
    shortName: 'Smriti Mandhana',
    title: 'Smriti Mandhana',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 112
  },
  {
    id: '63cbff6996851a4d7f9285aa',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44708',
    teamId: 9536,
    firstName: 'Harmanpreet Kaur',
    lastName: '',
    middleName: '',
    shortName: 'Harmanpreet Kaur',
    title: 'Harmanpreet Kaur',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 84
  },
  {
    id: '63cbff6996851a4d7f9285ac',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44714',
    teamId: 9536,
    firstName: 'Shikha Pandey',
    lastName: '',
    middleName: '',
    shortName: 'S Pandey',
    title: 'Shikha Pandey',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 10
  },
  {
    id: '63cbff6996851a4d7f9285af',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44718',
    teamId: 9536,
    firstName: 'Sushma Verma',
    lastName: '',
    middleName: '',
    shortName: 'S Verma',
    title: 'Sushma Verma',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbff6996851a4d7f9285b0',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44728',
    teamId: 9536,
    firstName: 'Rajeshwari Gayakwad',
    lastName: '',
    middleName: '',
    shortName: 'Rajeshwari Gayakwad',
    title: 'Rajeshwari Gayakwad',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 84
  },
  {
    id: '63cbff6996851a4d7f9285b1',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44740',
    teamId: 9536,
    firstName: 'Deepti Sharma',
    lastName: '',
    middleName: '',
    shortName: 'Deepti Sharma',
    title: 'Deepti Sharma',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 100,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 203
  },
  {
    id: '63cbff6996851a4d7f9285b2',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44801',
    teamId: 9536,
    firstName: 'Sneh Rana',
    lastName: '',
    middleName: '',
    shortName: 'Sneh Rana',
    title: 'Sneh Rana',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 53
  },
  {
    id: '63cbff6996851a4d7f9285b4',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '47751',
    teamId: 9536,
    firstName: 'Devika Vaidya',
    lastName: '',
    middleName: '',
    shortName: 'DP Vaidya',
    title: 'Devika Vaidya',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 69
  },
  {
    id: '63cbff6996851a4d7f9285b6',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '47819',
    teamId: 9536,
    firstName: 'Sabbhineni Meghana',
    lastName: '',
    middleName: '',
    shortName: 'Sabbhineni Meghana',
    title: 'Sabbhineni Meghana',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbff6996851a4d7f9285b9',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '47825',
    teamId: 9536,
    firstName: 'Anjali Sarwani',
    lastName: '',
    middleName: '',
    shortName: 'K Anjali Sarwani',
    title: 'Anjali Sarwani',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 4
  },
  {
    id: '63cbff6996851a4d7f9285ba',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '47874',
    teamId: 9536,
    firstName: 'Pooja Vastrakar',
    lastName: '',
    middleName: '',
    shortName: 'Pooja Vastrakar',
    title: 'Pooja Vastrakar',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbff6996851a4d7f9285bc',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '47892',
    teamId: 9536,
    firstName: 'Harleen Deol',
    lastName: '',
    middleName: '',
    shortName: 'Harleen Deol',
    title: 'Harleen Deol',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 31
  },
  {
    id: '63cbff6996851a4d7f9285bf',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '47899',
    teamId: 9536,
    firstName: 'Renuka Singh',
    lastName: '',
    middleName: '',
    shortName: 'Renuka Singh',
    title: 'Renuka Singh',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbff6996851a4d7f9285c0',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '47972',
    teamId: 9536,
    firstName: 'Radha Yadav',
    lastName: '',
    middleName: '',
    shortName: 'Radha Yadav',
    title: 'Radha Yadav',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 84
  },
  {
    id: '63cbff6996851a4d7f9285c2',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '47979',
    teamId: 9536,
    firstName: 'Yastika Bhatia',
    lastName: '',
    middleName: '',
    shortName: 'Yastika Bhatia',
    title: 'Yastika Bhatia',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 103
  },
  {
    id: '63cbff6996851a4d7f9285c6',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '52074',
    teamId: 9536,
    firstName: 'Meghna Singh',
    lastName: '',
    middleName: '',
    shortName: 'Meghna Singh',
    title: 'Meghna Singh',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbff6996851a4d7f9285c9',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '52086',
    teamId: 9536,
    firstName: 'Jemimah Rodrigues',
    lastName: '',
    middleName: '',
    shortName: 'Jemimah Rodrigues',
    title: 'Jemimah Rodrigues',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 6
  },
  {
    id: '63cbff6996851a4d7f9285fd',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '104665',
    teamId: 10279,
    firstName: 'Anneke Bosch',
    lastName: '',
    middleName: '',
    shortName: 'Anneke Bosch',
    title: 'Anneke Bosch',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 13
  },
  {
    id: '63cbff6996851a4d7f928604',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '104671',
    teamId: 10279,
    firstName: 'Annerie Dercksen',
    lastName: '',
    middleName: '',
    shortName: 'Annerie Dercksen',
    title: 'Annerie Dercksen',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 10
  },
  {
    id: '63cbff6996851a4d7f9285d1',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44747',
    teamId: 10279,
    firstName: 'Marizanne Kapp',
    lastName: '',
    middleName: '',
    shortName: 'M Kapp',
    title: 'Marizanne Kapp',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 79
  },
  {
    id: '63cbff6996851a4d7f9285d4',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44749',
    teamId: 10279,
    firstName: 'Chloe Tryon',
    lastName: '',
    middleName: '',
    shortName: 'CL Tryon',
    title: 'Chloe Tryon',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Medium Fast',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 58
  },
  {
    id: '63cbff6996851a4d7f9285d6',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44753',
    teamId: 10279,
    firstName: 'Sune Luus',
    lastName: '',
    middleName: '',
    shortName: 'S Luus',
    title: 'Sune Luus',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Leg Spin',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 100,
    totalPointsOfPreviousMatches: 45
  },
  {
    id: '63cbff6996851a4d7f9285da',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44759',
    teamId: 10279,
    firstName: 'Shabnim Ismail',
    lastName: '',
    middleName: '',
    shortName: 'S Ismail',
    title: 'Shabnim Ismail',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbff6996851a4d7f9285dd',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44761',
    teamId: 10279,
    firstName: 'Masabata Klaas',
    lastName: '',
    middleName: '',
    shortName: 'M Klaas',
    title: 'Masabata Klaas',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 199
  },
  {
    id: '63cbff6996851a4d7f9285e0',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44772',
    teamId: 10279,
    firstName: 'Ayabonga Khaka',
    lastName: '',
    middleName: '',
    shortName: 'A Khaka',
    title: 'Ayabonga Khaka',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 63
  },
  {
    id: '63cbff6996851a4d7f9285e3',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '44809',
    teamId: 10279,
    firstName: 'Lara Goodall',
    lastName: '',
    middleName: '',
    shortName: 'L Goodall',
    title: 'Lara Goodall',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63cbff6996851a4d7f9285e6',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '46392',
    teamId: 10279,
    firstName: 'Laura Wolvaardt',
    lastName: '',
    middleName: '',
    shortName: 'L Wolvaardt',
    title: 'Laura Wolvaardt',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 96
  },
  {
    id: '63cbff6996851a4d7f9285e9',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '46408',
    teamId: 10279,
    firstName: 'Delmi Tucker',
    lastName: '',
    middleName: '',
    shortName: 'D Tucker',
    title: 'Delmi Tucker',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 14
  },
  {
    id: '63cbff6996851a4d7f9285ec',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '46412',
    teamId: 10279,
    firstName: 'Tazmin Brits',
    lastName: '',
    middleName: '',
    shortName: 'T Brits',
    title: 'Tazmin Brits',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 71
  },
  {
    id: '63cbff6996851a4d7f9285ef',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '46413',
    teamId: 10279,
    firstName: 'Sinalo Jafta',
    lastName: '',
    middleName: '',
    shortName: 'S Jafta',
    title: 'Sinalo Jafta',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Left hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 14
  },
  {
    id: '63cbff6996851a4d7f9285f1',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '46433',
    teamId: 10279,
    firstName: 'Tumi Sekhukhune',
    lastName: '',
    middleName: '',
    shortName: 'TS Sekhukhune',
    title: 'Tumi Sekhukhune',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Left hand Bat',
    bowlingStyle: 'Right Arm Fast Medium',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 64
  },
  {
    id: '63cbff6996851a4d7f9285f4',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '46542',
    teamId: 10279,
    firstName: 'Nadine de Klerk',
    lastName: '',
    middleName: '',
    shortName: 'N de Klerk',
    title: 'Nadine de Klerk',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 40
  },
  {
    id: '63cbff6996851a4d7f9285f7',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '46584',
    teamId: 10279,
    firstName: 'Nonkululeko Mlaba',
    lastName: '',
    middleName: '',
    shortName: 'N Mlaba',
    title: 'Nonkululeko Mlaba',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Left Arm Orthodox',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 126
  },
  {
    id: '63cbff6996851a4d7f9285fa',
    matchId: '63cbff1d96851a4d7f92725d',
    playerId: '46595',
    teamId: 10279,
    firstName: 'Tebogo Macheke',
    lastName: '',
    middleName: '',
    shortName: 'Tebogo Macheke',
    title: 'Tebogo Macheke',
    playingEleven: false,
    role: 'wk',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'South Africa',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  }
];
export const indWVsNzWU19PlayersList = [
  {
    id: '63d1796f96851a4d7f832af1',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '104448',
    teamId: 126918,
    firstName: 'Antonia Hamilton',
    lastName: '',
    middleName: '',
    shortName: 'Antonia Hamilton',
    title: 'Antonia Hamilton',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 200,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63d1796f96851a4d7f832af4',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '104449',
    teamId: 126918,
    firstName: 'Kayley Knight',
    lastName: '',
    middleName: '',
    shortName: 'Kayley Knight',
    title: 'Kayley Knight',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 200,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 12
  },
  {
    id: '63d1796f96851a4d7f832af7',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '104616',
    teamId: 126918,
    firstName: 'Kate Chandler',
    lastName: '',
    middleName: '',
    shortName: 'Kate Chandler',
    title: 'Kate Chandler',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63d1796f96851a4d7f832afa',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '112783',
    teamId: 126918,
    firstName: 'Tash Wakelin',
    lastName: '',
    middleName: '',
    shortName: 'Tash Wakelin',
    title: 'Tash Wakelin',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 58
  },
  {
    id: '63d1796f96851a4d7f832afd',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '113431',
    teamId: 126918,
    firstName: 'Emma Irwin',
    lastName: '',
    middleName: '',
    shortName: 'Emma Irwin',
    title: 'Emma Irwin',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 100,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63d1796f96851a4d7f832aff',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '113545',
    teamId: 126918,
    firstName: 'Paige Loggenberg',
    lastName: '',
    middleName: '',
    shortName: 'Paige Loggenberg',
    title: 'Paige Loggenberg',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 16
  },
  {
    id: '63d1796f96851a4d7f832b05',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '113878',
    teamId: 126918,
    firstName: 'Anna Browning',
    lastName: '',
    middleName: '',
    shortName: 'Anna Browning',
    title: 'Anna Browning',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 95
  },
  {
    id: '63d1796f96851a4d7f832b0a',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '113881',
    teamId: 126918,
    firstName: 'Izzy Sharp',
    lastName: '',
    middleName: '',
    shortName: 'Izzy Sharp',
    title: 'Izzy Sharp',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 16
  },
  {
    id: '63d1796f96851a4d7f832b0b',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '123130',
    teamId: 126918,
    firstName: 'Emma McLeod',
    lastName: '',
    middleName: '',
    shortName: 'Emma McLeod',
    title: 'Emma McLeod',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 52
  },
  {
    id: '63d1796f96851a4d7f832b0e',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '123131',
    teamId: 126918,
    firstName: 'Abigail Hotton',
    lastName: '',
    middleName: '',
    shortName: 'Abigail Hotton',
    title: 'Abigail Hotton',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 10
  },
  {
    id: '63d1796f96851a4d7f832b10',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '123132',
    teamId: 126918,
    firstName: 'Olivia Anderson',
    lastName: '',
    middleName: '',
    shortName: 'Olivia Anderson',
    title: 'Olivia Anderson',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 200,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63d1796f96851a4d7f832b11',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '123157',
    teamId: 126918,
    firstName: 'Louisa KotKamp',
    lastName: '',
    middleName: '',
    shortName: 'Louisa KotKamp',
    title: 'Louisa KotKamp',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63d1796f96851a4d7f832b13',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '123298',
    teamId: 126918,
    firstName: 'Kate Irwin',
    lastName: '',
    middleName: '',
    shortName: 'Kate Irwin',
    title: 'Kate Irwin',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 19
  },
  {
    id: '63d1796f96851a4d7f832ae8',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '96647',
    teamId: 126918,
    firstName: 'Fran Jonas',
    lastName: '',
    middleName: '',
    shortName: 'F Jonas',
    title: 'Fran Jonas',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63d1796f96851a4d7f832aea',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '96870',
    teamId: 126918,
    firstName: 'Izzy Gaze',
    lastName: '',
    middleName: '',
    shortName: 'Izzy Gaze',
    title: 'Izzy Gaze',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 43
  },
  {
    id: '63d1796f96851a4d7f832aec',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '97319',
    teamId: 126918,
    firstName: 'Georgia Plimmer',
    lastName: '',
    middleName: '',
    shortName: 'Georgia Plimmer',
    title: 'Georgia Plimmer',
    playingEleven: false,
    role: 'bat',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 200,
    captainPercentage: 100,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 72
  },
  {
    id: '63d1796f96851a4d7f832aee',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '97325',
    teamId: 126918,
    firstName: 'Natasha Codyre',
    lastName: '',
    middleName: '',
    shortName: 'Natasha Codyre',
    title: 'Natasha Codyre',
    playingEleven: false,
    role: 'bowl',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'New Zealand',
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 74
  },
  {
    id: '63d1796f96851a4d7f832b1a',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '105928',
    teamId: 126969,
    firstName: 'Najla Noushad',
    lastName: '',
    middleName: '',
    shortName: 'Najla Noushad',
    title: 'Najla Noushad',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63d1796f96851a4d7f832b1d',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '121152',
    teamId: 126969,
    firstName: 'Yashasri',
    lastName: '',
    middleName: '',
    shortName: 'Yashasri',
    title: 'Yashasri',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63d1796f96851a4d7f832b1f',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '121489',
    teamId: 126969,
    firstName: 'Shikha Shalot',
    lastName: '',
    middleName: '',
    shortName: 'Shikha Shalot',
    title: 'Shikha Shalot',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63d1796f96851a4d7f832b22',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '122222',
    teamId: 126969,
    firstName: 'Shweta Sanjay Sehrawat',
    lastName: '',
    middleName: '',
    shortName: 'Shweta Sehrawat',
    title: 'Shweta Sanjay Sehrawat',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 200,
    captainPercentage: 100,
    viceCaptainPercentage: 100,
    totalPointsOfPreviousMatches: 27
  },
  {
    id: '63d1796f96851a4d7f832b24',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '122223',
    teamId: 126969,
    firstName: 'Hrishita Niladri Basu',
    lastName: '',
    middleName: '',
    shortName: 'Hrishita Basu',
    title: 'Hrishita Niladri Basu',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 4
  },
  {
    id: '63d1796f96851a4d7f832b27',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '122224',
    teamId: 126969,
    firstName: 'Parshavi Gaurav Chopra',
    lastName: '',
    middleName: '',
    shortName: 'Parshavi Chopra',
    title: 'Parshavi Gaurav Chopra',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 200,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 156
  },
  {
    id: '63d1796f96851a4d7f832b28',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '122225',
    teamId: 126969,
    firstName: 'Archana Shivram Devi',
    lastName: '',
    middleName: '',
    shortName: 'Archana Devi',
    title: 'Archana Shivram Devi',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 51
  },
  {
    id: '63d1796f96851a4d7f832b2b',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '122226',
    teamId: 126969,
    firstName: 'Falak Mohd Nasir Naz',
    lastName: '',
    middleName: '',
    shortName: 'Falak Naz',
    title: 'Falak Mohd Nasir Naz',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63d1796f96851a4d7f832b2c',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '122227',
    teamId: 126969,
    firstName: 'Hurley Tanmay Gala',
    lastName: '',
    middleName: '',
    shortName: 'Hurley Gala',
    title: 'Hurley Tanmay Gala',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63d1796f96851a4d7f832b2f',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '122228',
    teamId: 126969,
    firstName: 'Mannat Sanjeev Kashyap',
    lastName: '',
    middleName: '',
    shortName: 'Mannat Kashyap',
    title: 'Mannat Sanjeev Kashyap',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 80
  },
  {
    id: '63d1796f96851a4d7f832b30',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '122229',
    teamId: 126969,
    firstName: 'Sonia Rajpal Mendhiya',
    lastName: '',
    middleName: '',
    shortName: 'Sonia Mendhiya',
    title: 'Sonia Rajpal Mendhiya',
    playingEleven: false,
    role: 'all',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63d1796f96851a4d7f832b33',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '122230',
    teamId: 126969,
    firstName: 'Titas Ranadeep Sadhu',
    lastName: '',
    middleName: '',
    shortName: 'Titas Sadhu',
    title: 'Titas Ranadeep Sadhu',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 43
  },
  {
    id: '63d1796f96851a4d7f832b3d',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '122231',
    teamId: 126969,
    firstName: 'Shabnam Md Shakil',
    lastName: '',
    middleName: '',
    shortName: 'Shabnam MD',
    title: 'Shabnam Md Shakil',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 0
  },
  {
    id: '63d1796f96851a4d7f832b3e',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '122232',
    teamId: 126969,
    firstName: 'Soumya Manish Tiwari',
    lastName: '',
    middleName: '',
    shortName: 'Soumya Tiwari',
    title: 'Soumya Manish Tiwari',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 51
  },
  {
    id: '63d1796f96851a4d7f832b4c',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '122233',
    teamId: 126969,
    firstName: 'Gongadi V Trisha',
    lastName: '',
    middleName: '',
    shortName: 'Gongadi Trisha',
    title: 'Gongadi V Trisha',
    playingEleven: false,
    role: 'bat',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8.5,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 4
  },
  {
    id: '63d1796f96851a4d7f832b4f',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '122234',
    teamId: 126969,
    firstName: 'Sonam Mukesh Yadav',
    lastName: '',
    middleName: '',
    shortName: 'Sonam Yadav',
    title: 'Sonam Mukesh Yadav',
    playingEleven: false,
    role: 'bowl',
    battingStyle: '',
    bowlingStyle: '',
    fieldingPosition: '',
    nationality: null,
    thumbUrl: '',
    rating: 8,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 10
  },
  {
    id: '63d1796f96851a4d7f832b15',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '96962',
    teamId: 126969,
    firstName: 'Shafali Verma',
    lastName: '',
    middleName: '',
    shortName: 'Shafali Verma',
    title: 'Shafali Verma',
    playingEleven: false,
    role: 'all',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Off Break',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 0,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 36
  },
  {
    id: '63d1796f96851a4d7f832b18',
    matchId: '63d1792496851a4d7f831eb1',
    playerId: '96981',
    teamId: 126969,
    firstName: 'Richa Ghosh',
    lastName: '',
    middleName: '',
    shortName: 'Richa Ghosh',
    title: 'Richa Ghosh',
    playingEleven: false,
    role: 'wk',
    battingStyle: 'Right Hand Bat',
    bowlingStyle: 'Right Arm Medium',
    fieldingPosition: '',
    nationality: 'India',
    thumbUrl: '',
    rating: 9,
    run: 0,
    boundary: 0,
    six: 0,
    thirtyRuns: 0,
    fiftyRuns: 0,
    halfCentury: 0,
    century: 0,
    dismissal: 0,
    wicket: 0,
    twoWicketHaul: 0,
    threeWicketHaul: 0,
    fourWicketHaul: 0,
    fiveWicketHaul: 0,
    maidenOver: 0,
    catch: 0,
    stump: 0,
    runOut: 0,
    runOutThrow: 0,
    runOutCatch: 0,
    startingEleven: 0,
    economyRate: 0,
    strikeRate: 0,
    points: 0,
    normalPercentage: 100,
    captainPercentage: 0,
    viceCaptainPercentage: 0,
    totalPointsOfPreviousMatches: 9
  }
];
